webpackJsonp([34,32],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _input = __webpack_require__(531);
	
	var _input2 = _interopRequireDefault(_input);
	
	var _input3 = __webpack_require__(525);
	
	var _input4 = _interopRequireDefault(_input3);
	
	var _rate = __webpack_require__(532);
	
	var _rate2 = _interopRequireDefault(_rate);
	
	var _base = __webpack_require__(530);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _rate3 = __webpack_require__(527);
	
	var _rate4 = _interopRequireDefault(_rate3);
	
	var _keys = __webpack_require__(91);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _vue = __webpack_require__(16);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _routes = __webpack_require__(424);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	var _vueRouter = __webpack_require__(896);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _vueResource = __webpack_require__(895);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _store = __webpack_require__(425);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _comps = __webpack_require__(418);
	
	var _comps2 = _interopRequireDefault(_comps);
	
	var _vueScroller = __webpack_require__(897);
	
	var _vueScroller2 = _interopRequireDefault(_vueScroller);
	
	var _resource = __webpack_require__(422);
	
	var _resource2 = _interopRequireDefault(_resource);
	
	var _scheme = __webpack_require__(423);
	
	var _scheme2 = _interopRequireDefault(_scheme);
	
	var _api = __webpack_require__(10);
	
	var _vant = __webpack_require__(685);
	
	__webpack_require__(534);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _keys2.default)(_comps2.default).forEach(function (key) {
	  _vue2.default.component('v-' + key, _comps2.default[key]);
	});
	
	_vue2.default.use(_vant.Dialog);
	_vue2.default.use(_vueResource2.default);
	_vue2.default.use(_vueRouter2.default);
	_vue2.default.use(_vueScroller2.default);
	_vue2.default.use(_rate4.default);
	_vue2.default.use(_input4.default);
	_vue2.default.directive('focus', {
	  inserted: function inserted(el) {
	    el.focus();
	  }
	});
	var router = new _vueRouter2.default({ routes: _routes2.default });
	router.beforeEach(function (_ref, from, next) {
	  var meta = _ref.meta,
	      path = _ref.path;
	
	  console.log('next: ' + path);
	  var _meta$auth = meta.auth,
	      auth = _meta$auth === undefined ? true : _meta$auth;
	
	  var isLogin = Boolean(_store2.default.state.user.userId);
	  if (auth && !isLogin && path !== '/login') {
	    var ua = window.navigator.userAgent.toLowerCase();
	    window.localStorage.setItem('path-after-login', path);
	    if (/micromessenger/.test(ua)) {
	      window.location.href = _api.WE_OAUTH_URL;
	    } else {
	      return next({ path: '/login' });
	    }
	  }
	  next();
	});
	
	window.resource = _resource2.default;
	window.$router = router;
	window.$store = _store2.default;
	window.$scheme = _scheme2.default;
	new _vue2.default({
	  store: _store2.default,
	  router: router,
	  data: {
	    eventHub: new _vue2.default()
	  }
	}).$mount('#app');

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(91);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _utils = __webpack_require__(60);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      resource: window.resource,
	      tipsTrigger: false,
	      isLoading: false,
	      leavePage: {
	        redirect: false,
	        pass: [],
	        to: ''
	      }
	    };
	  },
	  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
	    var _this = this;
	
	    if (!this.leavePage.redirect || this.leavePage.pass.some(function (item) {
	      return to.path.indexOf(item) > -1;
	    })) {
	      next();
	      return;
	    }
	    next(false);
	    setTimeout(function () {
	      _this.$router.replace(_this.leavePage.to);
	    }, 0);
	  },
	
	  methods: {
	    setTempParam: _utils2.default.setTempParam,
	    getTempParam: _utils2.default.getTempParam,
	    delayBack: _utils2.default.delayBack,
	    formatPrice: _utils2.default.formatPrice,
	    formatPriceNumber: _utils2.default.formatPriceNumber,
	    showLoading: _utils2.default.showLoading,
	    hideLoading: function hideLoading() {
	      this.isLoading = false;
	      _utils2.default.hideLoading();
	    },
	
	    showToast: _utils2.default.showToast,
	    hideToast: _utils2.default.hideToast,
	    setTitle: _utils2.default.setTitle,
	    getMonthlyRange: _utils2.default.getMonthlyRange,
	    hasPropertyDeep: _utils2.default.hasPropertyDeep,
	    formatTime: _utils2.default.formatTime,
	    formatDate: function formatDate(number) {
	      var date = new Date(number);
	      var year = date.getFullYear();
	      var month = date.getMonth() + 1;
	      if (month < 10) {
	        month = '0' + month;
	      }
	      var day = date.getDate();
	      if (day < 10) {
	        day = '0' + day;
	      }
	      return year + '-' + month + '-' + day;
	    },
	    validateKey: function validateKey(key, value) {
	      if (typeof value === 'number') {
	        value = value.toString();
	      }
	      if (key && $scheme && $scheme[key]) {
	        if (value) {
	          if ($scheme[key].regex.test(value.trim())) {
	            return { valid: true, msg: '' };
	          } else {
	            return { valid: false, msg: $scheme[key].tips };
	          }
	        } else {
	          if ($scheme[key].required) {
	            return { valid: false, msg: $scheme[key].tips };
	          }
	        }
	      }
	      return { valid: true, msg: '' };
	    },
	    validate: function validate(key) {
	      return this.tipsTrigger ? this.validateKey(key, this.param[key], $scheme).msg : '';
	    },
	    validateAll: function validateAll(param) {
	      var _this2 = this;
	
	      var invalide = (0, _keys2.default)(param).filter(function (item) {
	        var _validateKey = _this2.validateKey(item, param[item], $scheme),
	            valid = _validateKey.valid;
	
	        return !valid;
	      });
	      if (invalide.length > 0) {
	        return this.validateKey(invalide[0], param[invalide[0]], $scheme);
	      }
	      return { valid: true };
	    }
	  }
	};

/***/ }),
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.WE_OAUTH_URL = undefined;
	
	var _promise = __webpack_require__(50);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _axios = __webpack_require__(124);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function dealWithResult(data, resolve, reject) {
	  if (data.data.code && parseInt(data.data.code) === 100) {
	    resolve(data.data.data);
	  } else {
	    if (parseInt(data.data.code) === 401) {
	      window.$router.replace('/login');
	    }
	    reject(data.data.message);
	  }
	}
	
	function dealWithError(data, resolve, reject) {
	  reject(data.status + ' ' + data.statusText);
	}
	
	function post(url, body, token, param) {
	  return new _promise2.default(function (resolve, reject) {
	    _axios2.default.post('/vue' + url, body, { params: param, headers: { 'token': !token ? '' : token, 'locale': 'zh_CN' } }).then(function (response) {
	      dealWithResult(response, resolve, reject);
	    }, function (response) {
	      dealWithError(response, resolve, reject);
	    });
	  });
	}
	
	function put(url, body, token, param) {
	  return new _promise2.default(function (resolve, reject) {
	    _axios2.default.put('/vue' + url, body, { params: param, headers: { 'token': !token ? '' : token, 'locale': 'zh_CN' } }).then(function (response) {
	      dealWithResult(response, resolve, reject);
	    }, function (response) {
	      dealWithError(response, resolve, reject);
	    });
	  });
	}
	
	function get(url, param, token) {
	  return new _promise2.default(function (resolve, reject) {
	    _axios2.default.get('/vue' + url, { params: param, headers: { 'token': !token ? '' : token, 'locale': 'zh_CN' } }).then(function (response) {
	      dealWithResult(response, resolve, reject);
	    }).catch(function (error) {
	      dealWithError(error, resolve, reject);
	    });
	  });
	}
	
	function deleted(url, param, token) {
	  return new _promise2.default(function (resolve, reject) {
	    _axios2.default.delete('/vue' + url, { params: param, headers: { 'token': !token ? '' : token, 'locale': 'zh_CN' } }).then(function (response) {
	      dealWithResult(response, resolve, reject);
	    }, function (response) {
	      dealWithError(response, resolve, reject);
	    });
	  });
	}
	
	var WE_OAUTH_URL = exports.WE_OAUTH_URL = '/vue/oauth';
	exports.default = {
	  queryUserInfo: function queryUserInfo(companyId, employeeNo) {
	    return get('/queryUserInfo', { companyId: companyId, employeeNo: employeeNo });
	  },
	  queryUserInfo2: function queryUserInfo2(companyId, cardNo) {
	    return get('/queryUserInfo2', { companyId: companyId, cardNo: cardNo });
	  },
	  bindingWeixin: function bindingWeixin(param) {
	    return post('/bindingWeixin', param);
	  },
	  activateAccount: function activateAccount(param) {
	    return post('/activateAccount', param);
	  },
	  login: function login(info) {
	    return post('/login', info);
	  },
	  recharge: function recharge(userInfo, payType, rechargeAmount) {
	    return post('/recharge', { userId: userInfo.userId, companyId: userInfo.companyId, payType: payType, rechargeAmount: rechargeAmount }, userInfo.token);
	  },
	  evaluate: function evaluate(userInfo, orderId, param) {
	    return put('/evaluate', param, userInfo.token, { companyId: userInfo.companyId, userId: userInfo.userId, orderId: orderId });
	  },
	  getcommonPayInfo: function getcommonPayInfo(userInfo, orderId, payType) {
	    return put('/getcommonPayInfo', {}, userInfo.token, { companyId: userInfo.companyId, userId: userInfo.userId, orderId: orderId, payType: payType });
	  },
	  getPeriods: function getPeriods(userInfo) {
	    return get('/period', { token: userInfo.token, userId: userInfo.userId, companyId: userInfo.companyId });
	  },
	  getHomePage: function getHomePage(userInfo) {
	    return get('/getHomePage', { token: userInfo.token, userId: userInfo.userId, companyId: userInfo.companyId, hallId: userInfo.hallId });
	  },
	  getRecords: function getRecords(userInfo, type, page) {
	    return get('/getRecords', { token: userInfo.token, userId: userInfo.userId, companyId: userInfo.companyId, type: type, page: page });
	  },
	  queryHallDishPopulayity: function queryHallDishPopulayity(userInfo, start, end) {
	    return get('/queryHallDishPopulayity', { userId: userInfo.userId, companyId: userInfo.companyId, start: start, end: end, periodPlanKind: 0 }, userInfo.token);
	  },
	  queryUserDishPopulayity: function queryUserDishPopulayity(userInfo, start, end) {
	    return get('/queryUserDishPopulayity', { userId: userInfo.userId, companyId: userInfo.companyId, start: start, end: end, periodPlanKind: 0 }, userInfo.token);
	  },
	  queryConsumeOrders: function queryConsumeOrders(userInfo, start, end) {
	    return get('/queryConsumeOrders', { companyId: userInfo.companyId, userId: userInfo.userId, start: start, end: end }, userInfo.token);
	  },
	  queryRecharges: function queryRecharges(userInfo, start, end) {
	    return get('/queryRecharges', { companyId: userInfo.companyId, userId: userInfo.userId, start: start, end: end }, userInfo.token);
	  },
	  getOrderDetail: function getOrderDetail(userInfo, orderId) {
	    return get('/getOrderDetail', { token: userInfo.token, company: userInfo.companyId, user: userInfo.userId, orderId: orderId });
	  },
	  getBalance: function getBalance(userInfo) {
	    return get('/getBalance', { userId: userInfo.userId, companyId: userInfo.companyId }, userInfo.token);
	  },
	  subscribestatus: function subscribestatus(userInfo) {
	    return get('/subscribestatus', { companyId: userInfo.companyId, userId: userInfo.userId, openId: userInfo.openId, type: 'weixin' }, userInfo.token);
	  },
	  checkPhone: function checkPhone(param) {
	    return get('/checkPhone', param);
	  },
	  getVerificationCode: function getVerificationCode(userInfo, phoneNumber) {
	    return get('/getVerificationCode?companyId=' + userInfo.companyId + '&userId=' + userInfo.userId + '&phoneNumber=' + phoneNumber, {}, userInfo.token);
	  },
	  getVerificationCode2: function getVerificationCode2(phoneNumber) {
	    return get('/getVerificationCode2', { phoneNumber: phoneNumber });
	  },
	  getPeriodMenus: function getPeriodMenus(userInfo, hallId, periodPlanId) {
	    return get('/getPeriodMenus?userId=' + userInfo.userId + '&companyId=' + userInfo.companyId, { hallId: hallId, periodPlanId: periodPlanId }, userInfo.token);
	  },
	  addOrder: function addOrder(userInfo, param) {
	    return post('/addOrder', param, userInfo.token, userInfo);
	  },
	  getPayInfo: function getPayInfo(userInfo, orderIds, payType) {
	    return get('/pay?user=' + userInfo.userId + '&openId=' + (userInfo.openId ? userInfo.openId : '') + '&orderIds=' + orderIds + '&payType=' + payType, {}, userInfo.token);
	  },
	  modifyPwd: function modifyPwd(param) {
	    return get('/modifyPwd', param, param.token);
	  },
	  deleteOrder: function deleteOrder(userInfo, orderId) {
	    return deleted('/deleteOrder', { token: userInfo.token, companyId: userInfo.companyId, userId: userInfo.userId, orderId: orderId });
	  },
	  getPersonQrCodeString: function getPersonQrCodeString(userInfo) {
	    return get('/getPersonQrCodeString', userInfo, userInfo.token);
	  },
	  getAddressList: function getAddressList(companyId) {
	    return get('/getAddressList', { companyId: companyId });
	  },
	  transferBedWithAddress: function transferBedWithAddress(userInfo, orderId, address) {
	    return get('/transferBedWithAddress', { companyId: userInfo.companyId, userId: userInfo.userId, orderId: orderId, address: address }, userInfo.token);
	  },
	  getPatientInfo: function getPatientInfo(userInfo, patientNo) {
	    return get('/getPatientInfo', { userId: userInfo.userId, companyId: userInfo.companyId, patientNo: patientNo }, userInfo.token);
	  },
	  companyInfo: function companyInfo(companyName) {
	    return get('/companies', { companyName: companyName });
	  },
	  getUserDeliveryAddress: function getUserDeliveryAddress(userInfo) {
	    return get('/getUserDeliveryAddress', userInfo, userInfo.token);
	  },
	  addUserDeliveryAddress: function addUserDeliveryAddress(userInfo, param) {
	    return post('/addUserDeliveryAddress', param, userInfo.token, userInfo);
	  },
	  deleteUserDeliveryAddress: function deleteUserDeliveryAddress(userInfo, addressId) {
	    return deleted('/deleteUserDeliveryAddress', { userId: userInfo.userId, companyId: userInfo.companyId, addressId: addressId }, userInfo.token);
	  },
	  unbindingWeixin: function unbindingWeixin(userInfo) {
	    return post('/unbindingWeixin', { companyId: userInfo.companyId, userId: userInfo.userId }, userInfo.token);
	  },
	  bindingPhoneNumber: function bindingPhoneNumber(userInfo, param) {
	    return post('/bindingPhoneNumber', param, userInfo.token);
	  },
	  weixinSignUpNew: function weixinSignUpNew(param) {
	    return post('/weixinSignUpNew', param);
	  },
	  weixinSignUpBindOld: function weixinSignUpBindOld(param) {
	    return post('/weixinSignUpBindOld', param);
	  },
	  weixinSignUpNewCardNo: function weixinSignUpNewCardNo(param) {
	    return post('/weixinSignUpNewCardNo', param);
	  },
	  weixinSignUpBindOldCardNo: function weixinSignUpBindOldCardNo(param) {
	    return post('/weixinSignUpBindOldCardNo', param);
	  },
	  searchUserInfo: function searchUserInfo(param) {
	    return get('/searchUserInfo', param);
	  },
	  weixinActivation: function weixinActivation(param) {
	    return post('/weixinActivation', param);
	  },
	  changeCard: function changeCard(userInfo, param) {
	    return post('/changeCard', param, userInfo.token);
	  },
	  querySubscription: function querySubscription(userInfo) {
	    return get('/querySubscription', { userId: userInfo.userId, companyId: userInfo.companyId }, userInfo.token);
	  },
	  relieveSubscription: function relieveSubscription(userInfo) {
	    return deleted('/relieveSubscription', { userId: userInfo.userId, companyId: userInfo.companyId }, userInfo.token);
	  },
	  getQuickBill: function getQuickBill(userInfo) {
	    return get('/getQuickBill', { userId: userInfo.userId, companyId: userInfo.companyId, pageNo: 1, pageSize: 10000, baseOrderViewStatus: 'NOT_CONSUME,CONSUMED,COMMENTED' }, userInfo.token);
	  }
	};

/***/ }),
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.UPDATE_PATIENT_INFO = exports.WRITE_USER_INFO = exports.USER_SIGNOUT = exports.USER_SIGNIN = undefined;
	
	var _promise = __webpack_require__(50);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _defineProperty2 = __webpack_require__(61);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _keys = __webpack_require__(91);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _assign = __webpack_require__(40);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _stringify = __webpack_require__(35);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _mutations, _actions;
	
	var _vue = __webpack_require__(16);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _api = __webpack_require__(10);
	
	var _api2 = _interopRequireDefault(_api);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var USER_SIGNIN = exports.USER_SIGNIN = 'USER_SIGNIN';var USER_SIGNOUT = exports.USER_SIGNOUT = 'USER_SIGNOUT';var WRITE_USER_INFO = exports.WRITE_USER_INFO = 'WRITE_USER_INFO';var UPDATE_PATIENT_INFO = exports.UPDATE_PATIENT_INFO = 'UPDATE_PATIENT_INFO';exports.default = {
	  state: JSON.parse(sessionStorage.getItem('user')) || {},
	  mutations: (_mutations = {}, (0, _defineProperty3.default)(_mutations, USER_SIGNIN, function (state, user) {
	    sessionStorage.setItem('user', (0, _stringify2.default)(user));
	    (0, _assign2.default)(state, user);
	  }), (0, _defineProperty3.default)(_mutations, USER_SIGNOUT, function (state) {
	    sessionStorage.removeItem('user');
	    (0, _keys2.default)(state).forEach(function (k) {
	      return _vue2.default.delete(state, k);
	    });
	  }), (0, _defineProperty3.default)(_mutations, UPDATE_PATIENT_INFO, function (state, data) {
	    var user = JSON.parse((0, _stringify2.default)(state));
	    user.address = data.patientBed;
	    user.patientIndicateTags = data.patientIndicateTags;
	    user.bedPatientName = data.patientName;
	    user.patientSpecialDiet = data.patientSpecialDiet;
	    sessionStorage.setItem('user', (0, _stringify2.default)(user));
	    (0, _assign2.default)(state, user);
	  }), _mutations),
	  actions: (_actions = {}, (0, _defineProperty3.default)(_actions, USER_SIGNIN, function (_ref, user) {
	    var commit = _ref.commit;
	
	    return new _promise2.default(function (resolve, reject) {
	      _api2.default.login(user).then(function (data) {
	        data.hallId = 13;
	        commit(USER_SIGNIN, data);
	        resolve();
	      }, function (data) {
	        commit(USER_SIGNOUT);
	        reject(data);
	      });
	    });
	  }), (0, _defineProperty3.default)(_actions, USER_SIGNOUT, function (_ref2) {
	    var commit = _ref2.commit;
	
	    commit(USER_SIGNOUT);
	  }), (0, _defineProperty3.default)(_actions, WRITE_USER_INFO, function (_ref3, user) {
	    var commit = _ref3.commit;
	
	    commit(USER_SIGNIN, user);
	  }), (0, _defineProperty3.default)(_actions, UPDATE_PATIENT_INFO, function (_ref4, patientNo) {
	    var commit = _ref4.commit,
	        state = _ref4.state;
	
	    return new _promise2.default(function (resolve, reject) {
	      _api2.default.getPatientInfo(state, patientNo).then(function (data) {
	        commit(UPDATE_PATIENT_INFO, data);
	        resolve();
	      }, function (data) {
	        reject(data);
	      });
	    });
	  }), _actions)
	};

/***/ }),
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CLEAR_ORDERED_DISH_BY_PERIOD_ID = exports.COMMIT_ORDER = exports.ALL_PERIOD_PLAN_DISHES = exports.CHANGE_DISH_COUNT = exports.UPDATE_MENU_DISHES = exports.GET_PERIODS = undefined;
	
	var _set = __webpack_require__(429);
	
	var _set2 = _interopRequireDefault(_set);
	
	var _map = __webpack_require__(427);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _slicedToArray2 = __webpack_require__(432);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _getIterator2 = __webpack_require__(132);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _promise = __webpack_require__(50);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _defineProperty2 = __webpack_require__(61);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _stringify = __webpack_require__(35);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _assign = __webpack_require__(40);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _mutations, _actions;
	
	var _api = __webpack_require__(10);
	
	var _api2 = _interopRequireDefault(_api);
	
	var _vue = __webpack_require__(16);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _utils = __webpack_require__(60);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GET_PERIODS = exports.GET_PERIODS = 'GET_PERIODS';
	var UPDATE_MENU_DISHES = exports.UPDATE_MENU_DISHES = 'UPDATE_MENU_DISHES';
	var CHANGE_DISH_COUNT = exports.CHANGE_DISH_COUNT = 'CHANGE_DISH_COUNT';
	var ALL_PERIOD_PLAN_DISHES = exports.ALL_PERIOD_PLAN_DISHES = 'allPeriodPlanDishes_v4';
	var COMMIT_ORDER = exports.COMMIT_ORDER = 'COMMIT_ORDER';
	var CLEAR_ORDERED_DISH_BY_PERIOD_ID = exports.CLEAR_ORDERED_DISH_BY_PERIOD_ID = 'CLEAR_ORDERED_DISH_BY_PERIOD_ID';
	exports.default = {
	  state: { allPeriods: [], allDishes: JSON.parse(sessionStorage.getItem(ALL_PERIOD_PLAN_DISHES)) || {}, discountDic: {} },
	  mutations: (_mutations = {}, (0, _defineProperty3.default)(_mutations, GET_PERIODS, function (state, periods) {
	    (0, _assign2.default)(state, periods);
	  }), (0, _defineProperty3.default)(_mutations, UPDATE_MENU_DISHES, function (state, data) {
	    _vue2.default.set(state.allDishes, data.periodPlanId + '', data.data);
	    _vue2.default.set(state.discountDic, data.periodPlanId + '', data.discountDic);
	    sessionStorage.setItem(ALL_PERIOD_PLAN_DISHES, (0, _stringify2.default)(state.allDishes));
	  }), _mutations),
	  actions: (_actions = {
	    getSelectedDish: function getSelectedDish(_ref, periodPlanId) {
	      var commit = _ref.commit,
	          state = _ref.state;
	
	      return new _promise2.default(function (resolve, reject) {
	        console.log(state);
	        var selectedDish = [];
	        if (state.allDishes[periodPlanId]['dishes'] === undefined || !Array.isArray(state.allDishes[periodPlanId]['dishes'])) return [];
	        state.allDishes[periodPlanId]['dishes'].forEach(function (cate) {
	          cate.items.forEach(function (dish) {
	            if (dish.count > 0) {
	              selectedDish.push(dish);
	            }
	          });
	        });
	        resolve(JSON.parse((0, _stringify2.default)(selectedDish)));
	      }, function (data) {
	        reject(data);
	      });
	    }
	  }, (0, _defineProperty3.default)(_actions, GET_PERIODS, function (_ref2, user) {
	    var commit = _ref2.commit;
	
	    return new _promise2.default(function (resolve, reject) {
	      _api2.default.getPeriods(user).then(function (data) {
	        commit(GET_PERIODS, data);
	        resolve();
	      }, function (data) {
	        commit(GET_PERIODS, {});
	        reject(data);
	      });
	    });
	  }), (0, _defineProperty3.default)(_actions, UPDATE_MENU_DISHES, function (_ref3, param) {
	    var state = _ref3.state,
	        commit = _ref3.commit;
	
	    return new _promise2.default(function (resolve, reject) {
	      _api2.default.getPeriodMenus(param.user, param.hallId, param.periodPlanId).then(function (data) {
	        var discounts = data.discounts;
	
	        var dishes = data.cates.sort(function (a, b) {
	          return a.catePriority - b.catePriority;
	        });
	
	        dishes.forEach(function (cate, cateIndex) {
	          cate.items.forEach(function (dish, dishIndex) {
	            dish.cateIndex = cateIndex;
	            dish.dishIndex = dishIndex;
	            dish.periodPlanId = param.periodPlanId;
	            dish.tags.forEach(function (tag) {
	              if (!_utils2.default.checkTimeReached(cate.cateEndTime) && tag.limitType === 1 && tag.checkType === 1) {
	                if (tag.userLeastAmount > 0) {
	                  dish.count = tag.userLeastAmount;
	                  dish.userLeastAmount = tag.userLeastAmount;
	                  dish.decDisabled = true;
	                }
	              }
	            });
	          });
	        });
	
	        var selectedDish = getSelectedDish(state, param.periodPlanId);
	        if (selectedDish.length > 0) {
	          selectedDish.forEach(function (d) {
	            dishes.forEach(function (cate) {
	              if (!_utils2.default.checkTimeReached(cate.cateEndTime)) {
	                cate.items.forEach(function (dish) {
	                  if (dish.itemId === d.itemId) {
	                    dish.count = d.count;
	                    dish.addDisabled = d.addDisabled ? d.addDisabled : undefined;
	                    dish.decDisabled = d.decDisabled ? d.decDisabled : undefined;
	                  }
	                });
	              }
	            });
	          });
	        }
	        commit(UPDATE_MENU_DISHES, { periodPlanId: param.periodPlanId, data: { dishes: dishes, discounts: discounts } });
	        resolve();
	      }, function (data) {
	        commit(UPDATE_MENU_DISHES, { periodPlanId: param.periodPlanId, data: {} });
	        reject(data);
	      });
	    });
	  }), (0, _defineProperty3.default)(_actions, CHANGE_DISH_COUNT, function (_ref4, param) {
	    var commit = _ref4.commit,
	        state = _ref4.state;
	
	    return new _promise2.default(function (resolve, reject) {
	      var data = JSON.parse((0, _stringify2.default)(state.allDishes));
	      var periodPlanId = param.dish.periodPlanId;
	      var allDishes = data[periodPlanId]['dishes'];
	      var discounts = data[periodPlanId]['discounts'];
	      var discountDic = {};
	      var cateIndex = param.dish.cateIndex;
	      var dishIndex = param.dish.dishIndex;
	      var cate = allDishes[cateIndex];
	      var dish = allDishes[cateIndex].items[dishIndex];
	      var needReject = false;
	      var rejectString = '';
	      if (param.optr === 'a') {
	        if (param.count > dish.limit) {
	          dish.addDisabled = true;
	          needReject = true;
	          rejectString = '超过库存限制';
	        }
	
	        if (_utils2.default.checkTimeReached(cate.cateEndTime)) {
	          needReject = true;
	          rejectString = '该类目菜品超出预点时间';
	        }
	
	        var singleAmount = checkSingleDishLimitAmount(dish);
	        if (singleAmount > 0) {
	          if (param.count >= singleAmount) {
	            dish.addDisabled = true;
	            if (param.count > singleAmount) {
	              needReject = true;
	              rejectString = dish.itemName + '\u9650\u70B9' + singleAmount + '\u4EFD';
	            }
	          }
	        }
	
	        var scopeCheckTips = checkScopeLimit(param, allDishes, dish);
	        if (scopeCheckTips.length > 0) {
	          commit(UPDATE_MENU_DISHES, { periodPlanId: periodPlanId, data: { dishes: allDishes, discounts: discounts } });
	          needReject = true;
	          rejectString = scopeCheckTips;
	        }
	      } else if (param.optr === 'd') {
	        var _singleAmount = checkSingleDishLeastAmount(dish);
	        if (_singleAmount > 0) {
	          if (param.count <= _singleAmount) {
	            dish.decDisabled = true;
	            if (param.count < _singleAmount) {
	              needReject = true;
	              rejectString = dish.itemName + '\u81F3\u5C11\u9700\u70B9' + _singleAmount + '\u4EFD';
	            }
	          }
	        }
	        checkScopeLimit(param, allDishes, dish);
	      }
	      if (needReject) {
	        reject(rejectString);
	      } else {
	        if (param.optr === 'a') {
	          dish.decDisabled = false;
	        } else {
	          dish.addDisabled = false;
	        }
	        allDishes[cateIndex].items[dishIndex].count = param.count;
	
	        var selectFoods = [];
	        if (allDishes && allDishes.length > 0) {
	          allDishes.forEach(function (good) {
	            good.items.forEach(function (food) {
	              if (food.count) {
	                selectFoods.push(food);
	              }
	            });
	          });
	        }
	
	        var discountArr = [];
	        if (discounts && discounts.length > 0) {
	          discounts.forEach(function (discountItem) {
	            if (discountItem.itemCategories !== undefined && discountItem.itemCategories.length > 0) {
	              var boolArr = [];
	              discountItem.itemCategories.forEach(function (categoryItem) {
	                var bool = false;
	                var cateArr = selectFoods.filter(function (selectFood) {
	                  return categoryItem.itemCategoryId === selectFood.cateId;
	                });
	                if (cateArr !== undefined && cateArr.length > 0) {
	                  var dishCount = 0;
	                  cateArr.forEach(function (cateFood) {
	                    dishCount += cateFood.count;
	                  });
	                  console.log(cateArr);
	                  console.log(dishCount);
	                  if (dishCount >= categoryItem.amount) {
	                    bool = true;
	                  } else {
	                    bool = false;
	                  }
	                }
	                boolArr.push(bool);
	              });
	              var bool = boolArr.every(function (item) {
	                return item === true;
	              });
	              if (bool) {
	                discountArr.push(discountItem);
	              }
	              boolArr.forEach(function (item) {
	                console.log(item);
	              });
	            } else {
	              var totalPrice = 0;
	              selectFoods.forEach(function (food) {
	                if (food.count) {
	                  totalPrice += food.positionPrice * food.count;
	                }
	              });
	              if (totalPrice > discountItem.totalPrice) {
	                discountArr.push(discountItem);
	              }
	            }
	          });
	          if (discountArr.length > 0) {
	            var totalPrice = 0;
	            selectFoods.forEach(function (food) {
	              if (food.count) {
	                totalPrice += food.positionPrice * food.count;
	              }
	            });
	            var priceArr = [];
	            discountArr.forEach(function (item) {
	              if (item.type === 1) {
	                priceArr.push({
	                  discount: item.discount,
	                  title: item.title,
	                  hallItemDiscountInfoId: item.hallItemDiscountInfoId
	                });
	              } else if (item.type === 2) {
	                priceArr.push({
	                  discount: totalPrice - item.fixedPrice,
	                  title: item.title,
	                  hallItemDiscountInfoId: item.hallItemDiscountInfoId
	                });
	              } else if (item.type === 3) {
	                priceArr.push({
	                  discount: item.discount,
	                  title: item.title,
	                  hallItemDiscountInfoId: item.hallItemDiscountInfoId
	                });
	              }
	            });
	            priceArr.sort(function (a, b) {
	              return b.discount - a.discount;
	            });
	            discountDic = priceArr[0];
	            console.log(discountDic);
	          }
	        }
	        commit(UPDATE_MENU_DISHES, { periodPlanId: periodPlanId, data: { dishes: allDishes, discounts: discounts }, discountDic: discountDic });
	        resolve();
	      }
	    });
	  }), (0, _defineProperty3.default)(_actions, COMMIT_ORDER, function (_ref5, param) {
	    var commit = _ref5.commit,
	        state = _ref5.state;
	
	    return new _promise2.default(function (resolve, reject) {
	      var needReject = false;
	      var rejectString = '';
	      var allowForceCommit = true;
	
	      var data = JSON.parse((0, _stringify2.default)(state.allDishes));
	
	      var singleDishRemind = checkSingleDishRemind(param, data);
	      if (singleDishRemind.length > 0) {
	        needReject = true;
	        rejectString = singleDishRemind;
	        allowForceCommit = true;
	      }
	
	      var scopeDishRemind = checkScopeDishRemind(param, data);
	      if (scopeDishRemind.length > 0) {
	        needReject = true;
	        rejectString = scopeDishRemind;
	        allowForceCommit = true;
	      }
	
	      var scopeCheckTips = checkScopeLeast(param, data);
	      if (scopeCheckTips.length > 0) {
	        needReject = true;
	        rejectString = scopeCheckTips;
	        allowForceCommit = false;
	      }
	      if (needReject) {
	        reject({ string: rejectString, allowForceCommit: allowForceCommit });
	      } else {
	        resolve();
	      }
	    });
	  }), (0, _defineProperty3.default)(_actions, CLEAR_ORDERED_DISH_BY_PERIOD_ID, function (_ref6, periodPlanId) {
	    var commit = _ref6.commit,
	        state = _ref6.state;
	
	    var data = JSON.parse((0, _stringify2.default)(state.allDishes));
	    if (data[periodPlanId] !== undefined) {
	      var dishes = data[periodPlanId]['dishes'];
	      var discounts = data[periodPlanId]['discounts'];
	      dishes.forEach(function (cate) {
	        if (cate.items.length > 0) {
	          cate.items.forEach(function (i) {
	            i.decDisabled = false;
	            i.addDisabled = false;
	            if (!i.userLeastAmount || i.userLeastAmount <= 0) {
	              i.count = 0;
	            }
	          });
	        }
	      });
	      commit(UPDATE_MENU_DISHES, { periodPlanId: periodPlanId, data: { dishes: dishes, discounts: discounts } });
	    }
	  }), _actions)
	};
	
	function checkSingleDishRemind(param, allDishes) {
	  var tips = '';
	  var commonDishes = allDishes[param.periodPlanId]['dishes'];
	  var nutritionDishes = allDishes[param.nutritionPeriodId];
	  console.log(commonDishes);
	  commonDishes.forEach(function (cate) {
	    cate.items.forEach(function (dish) {
	      dish.tags.forEach(function (tag) {
	        if (tag.limitType === 3 && tag.checkType === 1) {
	          if (dish.count === undefined || dish.count === 0) {
	            if (tips.length > 0) {
	              tips = tips + '\u3001"' + dish.itemName + '"';
	            } else {
	              tips = '\u60A8\u8FD8\u6CA1\u6709\u70B9"' + dish.itemName + '"';
	            }
	          }
	        }
	      });
	    });
	  });
	  if (Array.isArray(nutritionDishes) && nutritionDishes.length > 0) {
	    nutritionDishes.forEach(function (cate) {
	      cate.items.forEach(function (dish) {
	        dish.tags.forEach(function (tag) {
	          if (tag.limitType === 3 && tag.checkType === 1) {
	            if (dish.count === undefined || dish.count === 0) {
	              if (tips.length > 0) {
	                tips = tips + '\u3001"' + dish.itemName + '"';
	              } else {
	                tips = '\u60A8\u8FD8\u6CA1\u6709\u70B9"' + dish.itemName + '"';
	              }
	            }
	          }
	        });
	      });
	    });
	  }
	  if (tips.length > 0) {
	    tips = tips + '\uFF0C\u662F\u5426\u786E\u8BA4\u7ED3\u7B97\uFF1F';
	  }
	  return tips;
	}
	
	function checkScopeDishRemind(param, allDishes) {
	  var tips = '';
	  var map = makeTagDishMap(allDishes[param.periodPlanId]['dishes'], 3, 2);
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = (0, _getIterator3.default)(map.entries()), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var _step$value = (0, _slicedToArray3.default)(_step.value, 2),
	          tag = _step$value[0],
	          dishes = _step$value[1];
	
	      var totalCount = dishes.reduce(function (acc, cur) {
	        return acc + cur.count;
	      }, 0);
	      if (totalCount === 0) {
	        if (tips.length === 0) {
	          tips = '\u60A8\u8FD8\u6CA1\u6709\u70B9"' + tag.tagName + '"';
	        } else {
	          tips = tips + '\n\u60A8\u8FD8\u6CA1\u6709\u70B9"' + tag.tagName + '"';
	        }
	      }
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  map = makeTagDishMap(allDishes[param.nutritionPeriodId], 3, 2);
	  var _iteratorNormalCompletion2 = true;
	  var _didIteratorError2 = false;
	  var _iteratorError2 = undefined;
	
	  try {
	    for (var _iterator2 = (0, _getIterator3.default)(map.entries()), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	      var _step2$value = (0, _slicedToArray3.default)(_step2.value, 2),
	          tag = _step2$value[0],
	          dishes = _step2$value[1];
	
	      var _totalCount = dishes.reduce(function (acc, cur) {
	        return acc + cur.count;
	      }, 0);
	      if (_totalCount === 0) {
	        if (tips.length === 0) {
	          tips = '\u60A8\u8FD8\u6CA1\u6709\u70B9"' + tag.tagName + '"';
	        } else {
	          tips = tips + ';\n        \u60A8\u8FD8\u6CA1\u6709\u70B9"' + tag.tagName + '"';
	        }
	      }
	    }
	  } catch (err) {
	    _didIteratorError2 = true;
	    _iteratorError2 = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion2 && _iterator2.return) {
	        _iterator2.return();
	      }
	    } finally {
	      if (_didIteratorError2) {
	        throw _iteratorError2;
	      }
	    }
	  }
	
	  if (tips.length > 0) {
	    tips = tips + '\uFF0C\u662F\u5426\u786E\u8BA4\u7ED3\u7B97\uFF1F';
	  }
	  return tips;
	}
	
	function checkSingleDishLimitAmount(dish) {
	  var result = 999;
	  dish.tags.forEach(function (tag) {
	    if (tag.limitType === 1 && tag.checkType === 1) {
	      if (tag.userLimitAmount < result) {
	        result = tag.userLimitAmount;
	      }
	    }
	  });
	  return result;
	}
	
	function checkSingleDishLeastAmount(dish) {
	  var result = 0;
	  dish.tags.forEach(function (tag) {
	    if (tag.limitType === 1 && tag.checkType === 1) {
	      if (tag.userLeastAmount !== 0 && tag.userLeastAmount > result) {
	        result = tag.userLeastAmount;
	      }
	    }
	  });
	  return result;
	}
	
	function makeTagDishMap(allDishes, limitType, checkType) {
	  if (!Array.isArray(allDishes) || allDishes.length === 0) {
	    return new _map2.default();
	  }
	  var map = new _map2.default();
	  var set = new _set2.default();
	  allDishes.forEach(function (cate) {
	    cate.items.forEach(function (dish) {
	      dish.tags.forEach(function (tag) {
	        if (tag.limitType === limitType && tag.checkType === checkType) {
	          var exist = false;
	          var _iteratorNormalCompletion3 = true;
	          var _didIteratorError3 = false;
	          var _iteratorError3 = undefined;
	
	          try {
	            for (var _iterator3 = (0, _getIterator3.default)(set.values()), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	              var item = _step3.value;
	
	              if (item.tagId === tag.tagId) {
	                exist = true;
	              }
	            }
	          } catch (err) {
	            _didIteratorError3 = true;
	            _iteratorError3 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion3 && _iterator3.return) {
	                _iterator3.return();
	              }
	            } finally {
	              if (_didIteratorError3) {
	                throw _iteratorError3;
	              }
	            }
	          }
	
	          if (exist === false) {
	            set.add(tag);
	          }
	        }
	      });
	    });
	  });
	  var _iteratorNormalCompletion4 = true;
	  var _didIteratorError4 = false;
	  var _iteratorError4 = undefined;
	
	  try {
	    var _loop = function _loop() {
	      var item = _step4.value;
	
	      var dishArr = [];
	      allDishes.forEach(function (cate) {
	        cate.items.forEach(function (dish) {
	          dish.tags.forEach(function (tag) {
	            if (tag.tagId === item.tagId) {
	              dishArr.push(dish);
	            }
	          });
	        });
	      });
	      map.set(item, dishArr);
	    };
	
	    for (var _iterator4 = (0, _getIterator3.default)(set.values()), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	      _loop();
	    }
	  } catch (err) {
	    _didIteratorError4 = true;
	    _iteratorError4 = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion4 && _iterator4.return) {
	        _iterator4.return();
	      }
	    } finally {
	      if (_didIteratorError4) {
	        throw _iteratorError4;
	      }
	    }
	  }
	
	  return map;
	}
	
	function checkScopeLimit(param, allDishes, origDish) {
	  var map = makeTagDishMap(allDishes, 1, 2);
	  var tips = '';
	  if (param.optr === 'a') {
	    var canBeAddCount = true;
	    origDish.tags.forEach(function (dishTag) {
	      var _iteratorNormalCompletion5 = true;
	      var _didIteratorError5 = false;
	      var _iteratorError5 = undefined;
	
	      try {
	        for (var _iterator5 = (0, _getIterator3.default)(map.entries()), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
	          var _step5$value = (0, _slicedToArray3.default)(_step5.value, 2),
	              tag = _step5$value[0],
	              dishes = _step5$value[1];
	
	          if (dishTag.tagId === tag.tagId) {
	            var totalCount = dishes.reduce(function (acc, cur) {
	              return acc + cur.count;
	            }, 0);
	            if (totalCount > tag.userLimitAmount - 1) {
	              canBeAddCount = false;
	              tips = '"' + tag.tagName + '"\u7C7B\u83DC\u54C1\u6570\u91CF\u4E0D\u53EF\u8D85\u8FC7' + tag.userLimitAmount + '\u4EFD';
	            } else if (totalCount === tag.userLimitAmount - 1) {
	              dishes.forEach(function (dish) {
	                dish.addDisabled = true;
	              });
	            }
	          }
	        }
	      } catch (err) {
	        _didIteratorError5 = true;
	        _iteratorError5 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion5 && _iterator5.return) {
	            _iterator5.return();
	          }
	        } finally {
	          if (_didIteratorError5) {
	            throw _iteratorError5;
	          }
	        }
	      }
	    });
	    if (canBeAddCount) {
	      origDish.count++;
	    }
	  } else if (param.optr === 'd') {
	    origDish.tags.forEach(function (dishTag) {
	      var _iteratorNormalCompletion6 = true;
	      var _didIteratorError6 = false;
	      var _iteratorError6 = undefined;
	
	      try {
	        for (var _iterator6 = (0, _getIterator3.default)(map.entries()), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
	          var _step6$value = (0, _slicedToArray3.default)(_step6.value, 2),
	              tag = _step6$value[0],
	              dishes = _step6$value[1];
	
	          if (dishTag.tagId === tag.tagId) {
	            dishes.forEach(function (dish) {
	              dish.addDisabled = false;
	            });
	          }
	        }
	      } catch (err) {
	        _didIteratorError6 = true;
	        _iteratorError6 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion6 && _iterator6.return) {
	            _iterator6.return();
	          }
	        } finally {
	          if (_didIteratorError6) {
	            throw _iteratorError6;
	          }
	        }
	      }
	    });
	  }
	  return tips;
	}
	function checkScopeLeast(param, allDishes) {
	  var tips = '';
	  var map = makeTagDishMap(allDishes[param.periodPlanId]['dishes'], 1, 2);
	  var _iteratorNormalCompletion7 = true;
	  var _didIteratorError7 = false;
	  var _iteratorError7 = undefined;
	
	  try {
	    for (var _iterator7 = (0, _getIterator3.default)(map.entries()), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
	      var _step7$value = (0, _slicedToArray3.default)(_step7.value, 2),
	          tag = _step7$value[0],
	          dishes = _step7$value[1];
	
	      var totalCount = dishes.reduce(function (acc, cur) {
	        return acc + cur.count;
	      }, 0);
	      if (totalCount < tag.userLeastAmount) {
	        tips = '"' + tag.tagName + '"\u7C7B\u83DC\u54C1\u6570\u91CF\u81F3\u5C11\u70B9' + tag.userLeastAmount + '\u4EFD';
	      }
	    }
	  } catch (err) {
	    _didIteratorError7 = true;
	    _iteratorError7 = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion7 && _iterator7.return) {
	        _iterator7.return();
	      }
	    } finally {
	      if (_didIteratorError7) {
	        throw _iteratorError7;
	      }
	    }
	  }
	
	  map = makeTagDishMap(allDishes[param.nutritionPeriodId], 1, 2);
	  var _iteratorNormalCompletion8 = true;
	  var _didIteratorError8 = false;
	  var _iteratorError8 = undefined;
	
	  try {
	    for (var _iterator8 = (0, _getIterator3.default)(map.entries()), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
	      var _step8$value = (0, _slicedToArray3.default)(_step8.value, 2),
	          tag = _step8$value[0],
	          dishes = _step8$value[1];
	
	      var _totalCount2 = dishes.reduce(function (acc, cur) {
	        return acc + cur.count;
	      }, 0);
	      if (_totalCount2 < tag.userLeastAmount) {
	        tips = '"' + tag.tagName + '"\u7C7B\u83DC\u54C1\u6570\u91CF\u81F3\u5C11\u70B9' + tag.userLeastAmount + '\u4EFD';
	      }
	    }
	  } catch (err) {
	    _didIteratorError8 = true;
	    _iteratorError8 = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion8 && _iterator8.return) {
	        _iterator8.return();
	      }
	    } finally {
	      if (_didIteratorError8) {
	        throw _iteratorError8;
	      }
	    }
	  }
	
	  return tips;
	}
	function getSelectedDish(state, periodPlanId) {
	  var selectedDish = [];
	  if (state.allDishes[periodPlanId] === undefined || !Array.isArray(state.allDishes[periodPlanId])) return [];
	  state.allDishes[periodPlanId].forEach(function (cate) {
	    cate.items.forEach(function (dish) {
	      if (dish.count > 0) {
	        selectedDish.push(dish);
	      }
	    });
	  });
	  return JSON.parse((0, _stringify2.default)(selectedDish));
	}

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GET_MONTHLY_ORDERS = exports.REFRESH_MONTHLY_ORDERS = exports.SET_MONTHLY_REFRESH_LOCK = exports.SET_RECHARGE_LOCK = exports.SET_CONSUME_LOCK = exports.GET_RECHARGE_ORDERS = exports.GET_CONSUME_ORDERS = exports.GET_RECORDS = undefined;
	
	var _promise = __webpack_require__(50);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _defineProperty2 = __webpack_require__(61);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _stringify = __webpack_require__(35);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _mutations, _actions;
	
	var _api = __webpack_require__(10);
	
	var _api2 = _interopRequireDefault(_api);
	
	var _vue = __webpack_require__(16);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GET_RECORDS = exports.GET_RECORDS = 'GET_RECORDS';
	var GET_CONSUME_ORDERS = exports.GET_CONSUME_ORDERS = 'GET_CONSUME_ORDERS';
	var GET_RECHARGE_ORDERS = exports.GET_RECHARGE_ORDERS = 'GET_RECHARGE_ORDERS';
	var SET_CONSUME_LOCK = exports.SET_CONSUME_LOCK = 'SET_CONSUME_LOCK';
	var SET_RECHARGE_LOCK = exports.SET_RECHARGE_LOCK = 'SET_RECHARGE_LOCK';
	var SET_MONTHLY_REFRESH_LOCK = exports.SET_MONTHLY_REFRESH_LOCK = 'SET_MONTHLY_REFRESH_LOCK';
	var REFRESH_MONTHLY_ORDERS = exports.REFRESH_MONTHLY_ORDERS = 'REFRESH_MONTHLY_ORDERS';
	var GET_MONTHLY_ORDERS = exports.GET_MONTHLY_ORDERS = 'GET_MONTHLY_ORDERS';
	
	var finished = 'finished';
	var unfinished = 'unfinished';
	exports.default = {
	  state: { finishedOrders: [],
	    unfinishedOrders: [],
	    consumeOrders: [],
	    rechargeOrders: [],
	    monthDivideOrders: [],
	    monthOrdersRefreshFlag: false,
	    consumeLock: false,
	    rechargeLock: false },
	  mutations: (_mutations = {}, (0, _defineProperty3.default)(_mutations, GET_RECORDS, function (state, data) {
	    if (data.param === undefined) {
	      return;
	    }
	    if (data.param.type === finished) {
	      if (data.param.page === 1) {
	        _vue2.default.set(state, 'finishedOrders', data.data ? data.data.orders : []);
	      } else {
	        var oldOrders = JSON.parse((0, _stringify2.default)(state.finishedOrders));
	        Array.prototype.push.apply(oldOrders, data.data ? data.data.orders : []);
	        _vue2.default.set(state, 'finishedOrders', oldOrders);
	      }
	    } else if (data.param.type === unfinished) {
	      if (data.param.page === 1) {
	        _vue2.default.set(state, 'unfinishedOrders', data.data ? data.data.orders : []);
	      } else {
	        var _oldOrders = JSON.parse((0, _stringify2.default)(state.unfinishedOrders));
	        Array.prototype.push.apply(_oldOrders, data.data ? data.data.orders : []);
	        _vue2.default.set(state, 'unfinishedOrders', _oldOrders);
	      }
	    }
	  }), (0, _defineProperty3.default)(_mutations, GET_CONSUME_ORDERS, function (state, data) {
	    if (!data.data) {
	      _vue2.default.set(state, 'consumeOrders', []);
	      return;
	    }
	    if (data.page === 1) {
	      _vue2.default.set(state, 'consumeOrders', data.data);
	    } else {
	      var newOrder = state.consumeOrders.concat(data.data);
	      _vue2.default.set(state, 'consumeOrders', newOrder);
	    }
	  }), (0, _defineProperty3.default)(_mutations, GET_RECHARGE_ORDERS, function (state, data) {
	    if (!data.data) {
	      _vue2.default.set(state, 'rechargeOrders', []);
	      return;
	    }
	    if (data.page === 1) {
	      _vue2.default.set(state, 'rechargeOrders', data.data);
	    } else {
	      var newOrder = state.rechargeOrders.concat(data.data);
	      _vue2.default.set(state, 'rechargeOrders', newOrder);
	    }
	  }), (0, _defineProperty3.default)(_mutations, SET_CONSUME_LOCK, function (state, data) {
	    _vue2.default.set(state, 'consumeLock', data);
	  }), (0, _defineProperty3.default)(_mutations, SET_RECHARGE_LOCK, function (state, data) {
	    _vue2.default.set(state, 'rechargeLock', data);
	  }), (0, _defineProperty3.default)(_mutations, REFRESH_MONTHLY_ORDERS, function (state, data) {
	    _vue2.default.set(state, 'monthDivideOrders', data);
	  }), (0, _defineProperty3.default)(_mutations, SET_MONTHLY_REFRESH_LOCK, function (state, flagValue) {
	    _vue2.default.set(state, 'monthOrdersRefreshFlag', flagValue);
	  }), _mutations),
	  actions: (_actions = {}, (0, _defineProperty3.default)(_actions, GET_RECORDS, function (_ref, param) {
	    var commit = _ref.commit;
	
	    return new _promise2.default(function (resolve, reject) {
	      _api2.default.getRecords(param.user, param.param.type, param.param.page).then(function (data) {
	        commit(GET_RECORDS, { data: data, param: param.param });
	        resolve();
	      }, function (data) {
	        commit(GET_RECORDS, { finishedOrders: [], unfinishedOrders: [] });
	        reject(data);
	      });
	    });
	  }), (0, _defineProperty3.default)(_actions, GET_CONSUME_ORDERS, function (_ref2, param) {
	    var commit = _ref2.commit,
	        state = _ref2.state;
	
	    return new _promise2.default(function (resolve, reject) {
	      _api2.default.queryConsumeOrders(param.user, param.start, param.end).then(function (data) {
	        commit(GET_CONSUME_ORDERS, { data: data.orders ? data.orders : [], page: param.page });
	        divideOrderDataToMonthly(state);
	        resolve();
	      }, function (data) {
	        commit(GET_CONSUME_ORDERS, { consumeOrders: [] });
	        reject(data);
	      });
	    });
	  }), (0, _defineProperty3.default)(_actions, GET_RECHARGE_ORDERS, function (_ref3, param) {
	    var commit = _ref3.commit,
	        state = _ref3.state;
	
	    return new _promise2.default(function (resolve, reject) {
	      _api2.default.queryRecharges(param.user, param.start, param.end).then(function (data) {
	        commit(GET_RECHARGE_ORDERS, { data: data.userRecharges ? data.userRecharges : [], page: param.page });
	        divideOrderDataToMonthly(state);
	        resolve();
	      }, function (data) {
	        commit(GET_RECHARGE_ORDERS, { rechargeOrders: [] });
	        reject(data);
	      });
	    });
	  }), (0, _defineProperty3.default)(_actions, SET_CONSUME_LOCK, function (_ref4) {
	    var commit = _ref4.commit;
	
	    commit(SET_CONSUME_LOCK, true);
	    setTimeout(function () {
	      commit(SET_CONSUME_LOCK, false);
	    }, 1000 * 60);
	  }), (0, _defineProperty3.default)(_actions, SET_RECHARGE_LOCK, function (_ref5) {
	    var commit = _ref5.commit;
	
	    commit(SET_RECHARGE_LOCK, true);
	    setTimeout(function () {
	      commit(SET_RECHARGE_LOCK, false);
	    }, 1000 * 60);
	  }), (0, _defineProperty3.default)(_actions, SET_MONTHLY_REFRESH_LOCK, function (_ref6) {
	    var commit = _ref6.commit;
	
	    commit(SET_MONTHLY_REFRESH_LOCK, true);
	  }), (0, _defineProperty3.default)(_actions, REFRESH_MONTHLY_ORDERS, function (_ref7, param) {
	    var commit = _ref7.commit,
	        state = _ref7.state;
	
	    if (state.monthOrdersRefreshFlag === true) {
	      commit(SET_MONTHLY_REFRESH_LOCK, false);
	      _api2.default.queryConsumeOrders(param.user, param.start, param.end).then(function (data) {
	        commit(GET_CONSUME_ORDERS, { data: data.orders ? data.orders : [], page: param.page });
	        commit(REFRESH_MONTHLY_ORDERS, divideOrderDataToMonthly(state));
	      }, function (data) {
	        commit(GET_CONSUME_ORDERS, { consumeOrders: [] });
	      });
	      _api2.default.queryRecharges(param.user, param.start, param.end).then(function (data) {
	        commit(GET_RECHARGE_ORDERS, { data: data.userRecharges ? data.userRecharges : [], page: param.page });
	        commit(REFRESH_MONTHLY_ORDERS, divideOrderDataToMonthly(state));
	      }, function (data) {
	        commit(GET_RECHARGE_ORDERS, { rechargeOrders: [] });
	      });
	    }
	  }), _actions)
	};
	
	function divideOrderDataToMonthly(state) {
	  if (state.rechargeOrders.length === 0 && state.consumeOrders.length === 0) {
	    return [];
	  }
	  var earlyMonthMoment = (0, _moment2.default)(getEarliestTimeByAllOrders(state)).startOf('month');
	  var latestMonthMoment = (0, _moment2.default)(getLatestTimeByAllOrders(state)).startOf('month');
	
	  var monthRange = latestMonthMoment.diff(earlyMonthMoment, 'month');
	  var result = [];
	
	  var _loop = function _loop(i) {
	    var monthBeginMom = (0, _moment2.default)(getEarliestTimeByAllOrders(state)).startOf('month').add(i, 'month');
	    var monthEndMom = (0, _moment2.default)(getEarliestTimeByAllOrders(state)).add(i, 'month').endOf('month');
	    var date = monthBeginMom.format('YYYY年MM月');
	    var monthBeginTime = Date.parse(monthBeginMom);
	    var monthEndTime = Date.parse(monthEndMom);
	    var recharges = state.rechargeOrders.filter(function (r) {
	      return r.rechargeTime >= monthBeginTime && r.rechargeTime <= monthEndTime;
	    });
	    var consumes = state.consumeOrders.filter(function (c) {
	      return c.consumeDate >= monthBeginTime && c.consumeDate <= monthEndTime;
	    });
	    result.push({ date: date, begin: monthBeginTime, end: monthEndTime, recharges: recharges, consumes: consumes });
	  };
	
	  for (var i = 0; i <= monthRange; i++) {
	    _loop(i);
	  }
	  return result;
	}
	
	function getLatestTimeByAllOrders(state) {
	  if (state.consumeOrders.length === 0 && state.rechargeOrders.length === 0) {
	    return 0;
	  }
	  var latestTime = state.consumeOrders.reduce(function (acc, cur) {
	    return cur.consumeDate > acc ? cur.consumeDate : acc;
	  }, 0);
	  latestTime = state.rechargeOrders.reduce(function (acc, cur) {
	    return cur.rechargeTime > acc ? cur.rechargeTime : acc;
	  }, latestTime);
	  return latestTime;
	}
	
	function getEarliestTimeByAllOrders(state) {
	  if (state.consumeOrders.length === 0 && state.rechargeOrders.length === 0) {
	    return 0;
	  }
	  var earliestTime = state.consumeOrders.reduce(function (acc, cur) {
	    return cur.consumeDate < acc ? cur.consumeDate : acc;
	  }, 4449488461000);
	  earliestTime = state.rechargeOrders.reduce(function (acc, cur) {
	    return cur.rechargeTime < acc ? cur.rechargeTime : acc;
	  }, earliestTime);
	  return earliestTime;
	}

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  setTempParam: function setTempParam(param) {
	    window.temporaryParam = param;
	  },
	  getTempParam: function getTempParam() {
	    return window.temporaryParam;
	  },
	  delayBack: function delayBack() {
	    setTimeout(function () {
	      $router.back();
	    }, 1000);
	  },
	  formatTime: function formatTime(time) {
	    return (0, _moment2.default)(time).format('YYYY-MM-DD HH:mm:ss');
	  },
	  formatDateByDate: function formatDateByDate(date) {
	    return (0, _moment2.default)(date).format('YYYY-MM-DD');
	  },
	  startOfADay: function startOfADay(date) {
	    return (0, _moment2.default)(date).startOf('day').toDate().getTime();
	  },
	  datePlusOneDay: function datePlusOneDay(date) {
	    return (0, _moment2.default)(date).add(1, 'day').toDate();
	  },
	  dateMinusOneDay: function dateMinusOneDay(date) {
	    return (0, _moment2.default)(date).add(-1, 'day').toDate();
	  },
	  getMonthlyRange: function getMonthlyRange(startNum, endNum) {
	    if (typeof startNum !== 'number' || typeof endNum !== 'number') {
	      return undefined;
	    }
	    var startTime = (0, _moment2.default)(new Date()).add(startNum, 'month');
	    var endTime = (0, _moment2.default)(new Date()).add(endNum, 'month');
	    var start = startTime.startOf('month');
	    var end = endTime.endOf('month');
	    return {
	      start: Date.parse(start),
	      end: Date.parse(end)
	    };
	  },
	  setTitle: function setTitle(title) {
	    document.getElementsByTagName('title')[0].innerHTML = title;
	  },
	  formatPrice: function formatPrice(number, companyId) {
	    if (companyId == 198) {
	      return '券' + parseFloat(number / 100).toFixed(1) + '张';
	    } else {
	      return parseFloat(number / 100).toFixed(1) + '';
	    }
	  },
	  formatPriceNumber: function formatPriceNumber(number) {
	    return parseFloat(number / 100).toFixed(1);
	  },
	  checkTimeReached: function checkTimeReached(timeStamp) {
	    var now = new Date().getTime();
	    return timeStamp > 0 ? now > timeStamp : false;
	  },
	  showLoading: function showLoading(text) {
	    window.$app.$emit('loading', text);
	  },
	  hideLoading: function hideLoading() {
	    window.$app.$emit('loading', null);
	  },
	  showToast: function showToast(message, style) {
	    var autoCancel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	    window.$app.$emit('toast', message, autoCancel);
	  },
	  hideToast: function hideToast() {},
	  hasPropertyDeep: function hasPropertyDeep(data, props) {
	    if (!(data instanceof Object)) {
	      return false;
	    }
	    if (typeof props === 'string') {
	      return data[props] !== null && data[props] !== undefined;
	    }
	    if (!(props instanceof Array)) {
	      return false;
	    }
	    var curData = data;
	    for (var i = 0; i < props.length; i++) {
	      curData = curData[props[i]];
	      if (i === props.length - 1) {
	        return curData !== null && curData !== undefined;
	      }
	      if (!(curData instanceof Object)) {
	        return false;
	      }
	    }
	    return true;
	  }
	};

/***/ }),
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(16);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _keycode = __webpack_require__(615);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _overlay = __webpack_require__(750);
	
	var _overlay2 = _interopRequireDefault(_overlay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Overlay = _vue2.default.extend(_overlay2.default);
	
	var PopupManager = {
	  instances: [],
	  overlay: false,
	
	  open: function open(instance) {
	    if (!instance || this.instances.indexOf(instance) !== -1) return;
	    if (!this.overlay && instance.overlay) {
	      this.showOverlay(instance);
	    }
	    this.instances.push(instance);
	    this.changeOverlayStyle();
	  },
	  close: function close(instance) {
	    var _this = this;
	
	    var index = this.instances.indexOf(instance);
	    if (index === -1) return;
	    _vue2.default.nextTick(function () {
	      _this.instances.splice(index, 1);
	      if (_this.instances.length === 0) {
	        _this.closeOverlay();
	      }
	      _this.changeOverlayStyle();
	    });
	  },
	  showOverlay: function showOverlay(instance) {
	    var overlay = this.overlay = new Overlay({
	      el: document.createElement('div')
	    });
	    overlay.fixed = true;
	    overlay.color = instance.overlayColor;
	    overlay.opacity = instance.overlayOpacity;
	    overlay.zIndex = instance.overlayZIndex;
	    overlay.onClick = this.handleOverlayClick.bind(this);
	    document.body.appendChild(overlay.$el);
	    this.preventScrolling();
	    _vue2.default.nextTick(function () {
	      overlay.show = true;
	    });
	  },
	  preventScrolling: function preventScrolling() {
	    if (this.locked) return;
	
	    var body = document.getElementsByTagName('body')[0];
	    var html = document.getElementsByTagName('html')[0];
	    this.bodyOverflow = body.style.overflow;
	    this.htmlOverflow = html.style.overflow;
	    body.style.overflow = 'hidden';
	    html.style.overflow = 'hidden';
	    this.locked = true;
	  },
	  allowScrolling: function allowScrolling() {
	    var body = document.getElementsByTagName('body')[0];
	    var html = document.getElementsByTagName('html')[0];
	    body.style.overflow = this.bodyOverflow || '';
	    html.style.overflow = this.htmlOverflow || '';
	    this.bodyOverflow = null;
	    this.htmlOverflow = null;
	    this.locked = false;
	  },
	  closeOverlay: function closeOverlay() {
	    if (!this.overlay) return;
	    this.allowScrolling();
	    var overlay = this.overlay;
	    overlay.show = false;
	    this.overlay = null;
	    setTimeout(function () {
	      overlay.$el.remove();
	      overlay.$destroy();
	    }, 450);
	  },
	  changeOverlayStyle: function changeOverlayStyle() {
	    var instance = this.instances[this.instances.length - 1];
	    if (!this.overlay || this.instances.length === 0 || !instance.overlay) return;
	    this.overlay.color = instance.overlayColor;
	    this.overlay.opacity = instance.overlayOpacity;
	    this.overlay.zIndex = instance.overlayZIndex;
	  },
	  handleOverlayClick: function handleOverlayClick() {
	    if (this.instances.length === 0) return;
	    var instance = this.instances[this.instances.length - 1];
	    if (instance.overlayClick) {
	      instance.overlayClick();
	    }
	  }
	};
	window.addEventListener('keydown', function (e) {
	  if (PopupManager.instances.length === 0 || (0, _keycode2.default)(e) !== 'esc') return;
	  var instance = PopupManager.instances[PopupManager.instances.length - 1];
	  if (instance.escPress) {
	    instance.escPress();
	  }
	});
	
	exports.default = PopupManager;

/***/ }),
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _manager = __webpack_require__(71);
	
	var _manager2 = _interopRequireDefault(_manager);
	
	var _utils = __webpack_require__(419);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    open: {
	      type: Boolean,
	      default: false
	    },
	    overlay: {
	      type: Boolean,
	      default: true
	    },
	    overlayOpacity: {
	      type: Number,
	      default: 0.4
	    },
	    overlayColor: {
	      type: String,
	      default: '#000'
	    },
	    escPressClose: {
	      type: Boolean,
	      default: true
	    },
	    appendBody: {
	      type: Boolean,
	      default: true
	    }
	  },
	  data: function data() {
	    return {
	      overlayZIndex: (0, _utils.getZIndex)(),
	      zIndex: (0, _utils.getZIndex)()
	    };
	  },
	
	  methods: {
	    overlayClick: function overlayClick(e) {
	      if (this.overlay) this.$emit('close', 'overlay');
	    },
	    escPress: function escPress(e) {
	      if (this.escPressClose) this.$emit('close', 'esc');
	    },
	    clickOutSide: function clickOutSide(e) {
	      this.$emit('clickOutSide', e);
	    },
	    setZIndex: function setZIndex() {
	      var dom = this.$el;
	      if (!this.zIndex) this.zIndex = (0, _utils.getZIndex)();
	      if (dom) dom.style.zIndex = this.zIndex;
	    },
	    bindClickOutSide: function bindClickOutSide() {
	      var _this = this;
	
	      if (!this._handleClickOutSide) {
	        this._handleClickOutSide = function (e) {
	          if (_this.popupEl.contains(e.target)) return;
	          _this.clickOutSide(e);
	        };
	      }
	      setTimeout(function () {
	        document.addEventListener('click', _this._handleClickOutSide);
	      }, 0);
	    },
	    unBindClickOutSide: function unBindClickOutSide() {
	      document.removeEventListener('click', this._handleClickOutSide);
	    },
	    resetZIndex: function resetZIndex() {
	      this.overlayZIndex = (0, _utils.getZIndex)();
	      this.zIndex = (0, _utils.getZIndex)();
	    }
	  },
	  mounted: function mounted() {
	    this.popupEl = this.appendBody ? this.$refs.popup : this.$el;
	    if (this.open) {
	      _manager2.default.open(this);
	      this.bindClickOutSide();
	    }
	    if (!this.popupEl && this.appendBody) {
	      console.warn('必须有一个 ref=‘popup’ 的元素');
	      return;
	    }
	    if (this.appendBody) document.body.appendChild(this.popupEl);
	  },
	  updated: function updated() {
	    if (!this.overlay) {
	      this.setZIndex();
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    _manager2.default.close(this);
	    this.unBindClickOutSide();
	    if (this.appendBody && this.popupEl) document.body.removeChild(this.popupEl);
	  },
	
	  watch: {
	    open: function open(val, oldVal) {
	      if (val === oldVal) return;
	      if (val) {
	        this.bindClickOutSide();
	        this.resetZIndex();
	        _manager2.default.open(this);
	      } else {
	        this.unBindClickOutSide();
	        _manager2.default.close(this);
	      }
	    }
	  }
	};

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.UPDATE_DELIVERY_ADDRESS = undefined;
	
	var _promise = __webpack_require__(50);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _defineProperty2 = __webpack_require__(61);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _assign = __webpack_require__(40);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _vue = __webpack_require__(16);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _api = __webpack_require__(10);
	
	var _api2 = _interopRequireDefault(_api);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UPDATE_DELIVERY_ADDRESS = exports.UPDATE_DELIVERY_ADDRESS = 'UPDATE_DELIVERY_ADDRESS';exports.default = {
	  state: {
	    addresses: []
	  },
	  mutations: (0, _defineProperty3.default)({}, UPDATE_DELIVERY_ADDRESS, function (state, data) {
	    (0, _assign2.default)(state, data);
	    _vue2.default.set(state, 'addresses', data);
	  }),
	  actions: (0, _defineProperty3.default)({}, UPDATE_DELIVERY_ADDRESS, function (_ref, userInfo) {
	    var commit = _ref.commit;
	
	    return new _promise2.default(function (resolve, reject) {
	      _api2.default.getUserDeliveryAddress(userInfo).then(function (data) {
	        commit(UPDATE_DELIVERY_ADDRESS, data.list ? data.list : []);
	        resolve();
	      }, function (data) {
	        reject(data);
	      });
	    });
	  })
	};

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GET_HOMEPAGE = undefined;
	
	var _promise = __webpack_require__(50);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _defineProperty2 = __webpack_require__(61);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _assign = __webpack_require__(40);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _api = __webpack_require__(10);
	
	var _api2 = _interopRequireDefault(_api);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GET_HOMEPAGE = exports.GET_HOMEPAGE = 'GET_HOMEPAGE';
	
	exports.default = {
	  state: { dayPeriods: [], banners: [] },
	  mutations: (0, _defineProperty3.default)({}, GET_HOMEPAGE, function (state, periods) {
	    (0, _assign2.default)(state, periods);
	  }),
	  actions: (0, _defineProperty3.default)({}, GET_HOMEPAGE, function (_ref, user) {
	    var commit = _ref.commit;
	
	    return new _promise2.default(function (resolve, reject) {
	      _api2.default.getHomePage(user).then(function (data) {
	        commit(GET_HOMEPAGE, data);
	        resolve();
	      }, function (data) {
	        commit(GET_HOMEPAGE, { dayPeriods: [], banners: [] });
	        reject(data);
	      });
	    });
	  })
	};

/***/ }),
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/qrcode.d82a2bc.jpg";

/***/ }),
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */
/***/ (function(module, exports) {

	"use strict";
	
	(function () {
	  var b = {};var a = {};a.PADCHAR = "=";a.ALPHA = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";a.makeDOMException = function () {
	    var f, d;try {
	      return new DOMException(DOMException.INVALID_CHARACTER_ERR);
	    } catch (d) {
	      var c = new Error("DOM Exception 5");c.code = c.number = 5;c.name = c.description = "INVALID_CHARACTER_ERR";c.toString = function () {
	        return "Error: " + c.name + ": " + c.message;
	      };return c;
	    }
	  };a.getbyte64 = function (e, d) {
	    var c = a.ALPHA.indexOf(e.charAt(d));if (c === -1) {
	      throw a.makeDOMException();
	    }return c;
	  };a.decode = function (f) {
	    f = "" + f;var j = a.getbyte64;var h, e, g;var d = f.length;if (d === 0) {
	      return f;
	    }if (d % 4 !== 0) {
	      throw a.makeDOMException();
	    }h = 0;if (f.charAt(d - 1) === a.PADCHAR) {
	      h = 1;if (f.charAt(d - 2) === a.PADCHAR) {
	        h = 2;
	      }d -= 4;
	    }var c = [];for (e = 0; e < d; e += 4) {
	      g = j(f, e) << 18 | j(f, e + 1) << 12 | j(f, e + 2) << 6 | j(f, e + 3);c.push(String.fromCharCode(g >> 16, g >> 8 & 255, g & 255));
	    }switch (h) {case 1:
	        g = j(f, e) << 18 | j(f, e + 1) << 12 | j(f, e + 2) << 6;c.push(String.fromCharCode(g >> 16, g >> 8 & 255));break;case 2:
	        g = j(f, e) << 18 | j(f, e + 1) << 12;c.push(String.fromCharCode(g >> 16));break;}return c.join("");
	  };a.getbyte = function (e, d) {
	    var c = e.charCodeAt(d);if (c > 255) {
	      throw a.makeDOMException();
	    }return c;
	  };a.encode = function (f) {
	    if (arguments.length !== 1) {
	      throw new SyntaxError("Not enough arguments");
	    }var g = a.PADCHAR;var h = a.ALPHA;var k = a.getbyte;var e, j;var c = [];f = "" + f;var d = f.length - f.length % 3;if (f.length === 0) {
	      return f;
	    }for (e = 0; e < d; e += 3) {
	      j = k(f, e) << 16 | k(f, e + 1) << 8 | k(f, e + 2);c.push(h.charAt(j >> 18));c.push(h.charAt(j >> 12 & 63));c.push(h.charAt(j >> 6 & 63));c.push(h.charAt(j & 63));
	    }switch (f.length - d) {case 1:
	        j = k(f, e) << 16;c.push(h.charAt(j >> 18) + h.charAt(j >> 12 & 63) + g + g);break;case 2:
	        j = k(f, e) << 16 | k(f, e + 1) << 8;c.push(h.charAt(j >> 18) + h.charAt(j >> 12 & 63) + h.charAt(j >> 6 & 63) + g);break;}return c.join("");
	  };b.pay = function (d) {
	    var c = encodeURIComponent(a.encode(d));location.href = "../../../public/static/pay.html?goto=" + c;
	  };b.decode = function (c) {
	    return a.decode(decodeURIComponent(c));
	  };window._AP = b;
	})();

/***/ }),
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'swiper-slide',
	  data: function data() {
	    return {
	      slideClass: 'swiper-slide'
	    };
	  },
	  ready: function ready() {
	    this.update();
	  },
	  mounted: function mounted() {
	    this.update();
	    if (this.$parent.options.slideClass) {
	      this.slideClass = this.$parent.options.slideClass;
	    }
	  },
	  updated: function updated() {
	    this.update();
	  },
	  attached: function attached() {
	    this.update();
	  },
	  methods: {
	    update: function update() {
	      if (this.$parent && this.$parent.swiper && this.$parent.swiper.update) {
	        this.$parent.swiper.update(true);
	        if (this.$parent.options.loop) {
	          this.$parent.swiper.reLoop();
	        }
	      }
	    }
	  }
	};

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	var browser = typeof window !== 'undefined';
	if (browser) window.Swiper = __webpack_require__(277);
	exports.default = {
	  name: 'swiper',
	  props: {
	    options: {
	      type: Object,
	      default: function _default() {
	        return {
	          autoplay: 3500
	        };
	      }
	    },
	    notNextTick: {
	      type: Boolean,
	      default: function _default() {
	        return false;
	      }
	    }
	  },
	  data: function data() {
	    return {
	      defaultSwiperClasses: {
	        wrapperClass: 'swiper-wrapper'
	      }
	    };
	  },
	  ready: function ready() {
	    if (!this.swiper && browser) {
	      this.swiper = new Swiper(this.$el, this.options);
	    }
	  },
	  mounted: function mounted() {
	    var self = this;
	    var mount = function () {
	      if (!self.swiper && browser) {
	        delete self.options.notNextTick;
	        var setClassName = false;
	        for (var className in self.defaultSwiperClasses) {
	          if (self.defaultSwiperClasses.hasOwnProperty(className)) {
	            if (self.options[className]) {
	              setClassName = true;
	              self.defaultSwiperClasses[className] = self.options[className];
	            }
	          }
	        }
	        var mountInstance = function mountInstance() {
	          self.swiper = new Swiper(self.$el, self.options);
	        };
	        setClassName ? self.$nextTick(mountInstance) : mountInstance();
	      }
	    }(this.options.notNextTick || this.notNextTick) ? mount() : this.$nextTick(mount);
	  },
	  updated: function updated() {
	    if (this.swiper) {
	      this.swiper.update();
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    if (this.swiper) {
	      this.swiper.destroy();
	      delete this.swiper;
	    }
	  }
	};

/***/ }),
/* 338 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  data: function data() {
	    return {
	      transitionName: 'slide-left',
	      showLoading: false,
	      toast: {
	        show: false,
	        message: '',
	        timer: undefined
	      },
	      loading: {
	        show: false,
	        message: ''
	      }
	    };
	  },
	  created: function created() {
	    window.$app = this;
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    var loading = document.getElementById('bowl-wrapper');
	    if (loading.parentNode) {
	      loading.parentNode.removeChild(loading);
	    }
	    this.$on('toast', function (message, autoCancel) {
	      if (_this.toast.timer) {
	        clearTimeout(_this.toast.timer);
	        _this.toast.timer = undefined;
	      }
	      _this.toast.message = message;
	      _this.toast.show = true;
	      if (autoCancel) {
	        _this.toast.timer = setTimeout(function () {
	          _this.toast.message = undefined;
	          _this.toast.show = false;
	        }, 2000);
	      } else {}
	    });
	    this.$on('closeToast', function () {
	      _this.toast.message = undefined;
	      _this.toast.show = false;
	    });
	    this.$on('loading', function (message) {
	      _this.loading.show = message !== null;
	      _this.loading.message = message;
	    });
	  }
	};

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _qrcode = __webpack_require__(114);
	
	var _qrcode2 = _interopRequireDefault(_qrcode);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      qrcode: _qrcode2.default
	    };
	  }
	};

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vueAwesomeSwiper = __webpack_require__(732);
	
	__webpack_require__(533);
	
	exports.default = {
	  props: ['listImg'],
	  data: function data() {
	    return {
	      swiperOption: {
	        pagination: '.swiper-pagination',
	        paginationClickable: true,
	        autoplayDisableOnInteraction: false,
	        autoplay: 3000,
	        loop: this.listImg.length > 1
	      }
	    };
	  },
	  mounted: function mounted() {},
	
	  components: {
	    swiper: _vueAwesomeSwiper.swiper,
	    swiperSlide: _vueAwesomeSwiper.swiperSlide
	  },
	  methods: {
	    click: function click(index) {
	      this.$emit('imgClick', index);
	    }
	  }
	};

/***/ }),
/* 341 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    text: {
	      type: String
	    },
	    primary: {
	      type: Boolean,
	      default: false
	    },
	    secondary: {
	      type: Boolean,
	      default: false
	    },
	    default: {
	      type: Boolean,
	      default: false
	    },
	    disabled: {
	      type: Boolean,
	      default: false
	    },
	    fullWidth: {
	      type: Boolean,
	      default: false
	    },
	    danger: {
	      type: Boolean,
	      default: false
	    }
	  },
	  computed: {
	    buttonClass: function buttonClass() {
	      return {
	        'disabled': this.disabled,
	        'primary': this.primary,
	        'secondary': this.secondary,
	        'default': this.default,
	        'full-width': this.fullWidth,
	        'danger': this.danger
	      };
	    }
	  },
	  methods: {
	    handleClick: function handleClick(e) {
	      if (!this.disabled) {
	        this.$emit('click', e);
	      }
	    }
	  }
	};

/***/ }),
/* 342 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    paddingTop: {
	      type: String,
	      default: '0pt'
	    },
	    paddingBottom: {
	      type: String,
	      default: '0pt'
	    },
	    paddingLeft: {
	      type: String,
	      default: '0pt'
	    },
	    paddingRight: {
	      type: String,
	      default: '0pt'
	    }
	  },
	  computed: {
	    style: function style() {
	      return {
	        'padding-left': this.paddingLeft,
	        'padding-right': this.paddingRight,
	        'padding-top': this.paddingTop,
	        'padding-bottom': this.paddingBottom
	      };
	    }
	  }
	};

/***/ }),
/* 343 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    text: {
	      type: String
	    }
	  }
	};

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(60);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    value: {
	      type: Number,
	      default: _utils2.default.formatDateByDate(new Date().getTime())
	    },
	    minDateNumber: Number,
	    maxDateNumber: Number
	  },
	  computed: {
	    valueDate: function valueDate() {
	      return this.startOfADay(this.value);
	    },
	    minDate: function minDate() {
	      return this.startOfADay(this.minDateNumber);
	    },
	    maxDate: function maxDate() {
	      return this.startOfADay(this.maxDateNumber);
	    },
	    reachBottom: function reachBottom() {
	      return this.formatDateByDate(this.valueDate) <= this.formatDateByDate(this.minDate);
	    },
	    reachTop: function reachTop() {
	      return this.formatDateByDate(this.valueDate) >= this.formatDateByDate(this.maxDate);
	    }
	  },
	  created: function created() {
	    if (this.value) {
	      this.$emit('input', this.startOfADay(this.value));
	    }
	  },
	
	  methods: {
	    formatDateByDate: _utils2.default.formatDateByDate,
	    datePlusOneDay: _utils2.default.datePlusOneDay,
	    dateMinusOneDay: _utils2.default.dateMinusOneDay,
	    startOfADay: _utils2.default.startOfADay,
	    clickLast: function clickLast() {
	      if (this.reachBottom === false) {
	        this.$emit('input', this.startOfADay(this.dateMinusOneDay(this.value)));
	      }
	    },
	    clickNext: function clickNext() {
	      if (this.reachTop === false) {
	        this.$emit('input', this.startOfADay(this.datePlusOneDay(this.value)));
	      }
	    }
	  }
	};

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _popup = __webpack_require__(88);
	
	var _popup2 = _interopRequireDefault(_popup);
	
	var _manager = __webpack_require__(71);
	
	var _manager2 = _interopRequireDefault(_manager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  mixins: [_popup2.default],
	  props: {
	    title: {
	      type: String
	    },
	    cancelText: {
	      type: String,
	      default: '取消'
	    },
	    okText: {
	      type: String,
	      default: '确认'
	    }
	  },
	  methods: {
	    handleWrapperClick: function handleWrapperClick(e) {
	      var wrapperEl = this.$refs.popup;
	      if (wrapperEl === e.target) _manager2.default.handleOverlayClick();
	    },
	    cancel: function cancel() {
	      this.$emit('close');
	      this.$emit('cancal');
	    },
	    ok: function ok() {
	      this.$emit('close');
	      this.$emit('ok');
	    }
	  }
	};

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _popup = __webpack_require__(88);
	
	var _popup2 = _interopRequireDefault(_popup);
	
	var _manager = __webpack_require__(71);
	
	var _manager2 = _interopRequireDefault(_manager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  mixins: [_popup2.default],
	  props: {
	    title: {
	      type: String
	    },
	    contents: {
	      type: Array
	    },
	    cancelText: {
	      type: String,
	      default: '取消'
	    }
	  },
	  methods: {
	    handleWrapperClick: function handleWrapperClick(e) {
	      var wrapperEl = this.$refs.popup;
	      if (wrapperEl === e.target) _manager2.default.handleOverlayClick();
	    },
	    cancel: function cancel() {
	      this.$emit('close');
	      this.$emit('cancal');
	    },
	    clickItem: function clickItem(i) {
	      this.$emit('close');
	      this.$emit('ok', i);
	    }
	  }
	};

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _popup = __webpack_require__(88);
	
	var _popup2 = _interopRequireDefault(_popup);
	
	var _manager = __webpack_require__(71);
	
	var _manager2 = _interopRequireDefault(_manager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  mixins: [_popup2.default],
	  props: {
	    content: {
	      type: String
	    },
	    cancelText: {
	      type: String,
	      default: '取消'
	    },
	    okText: {
	      type: String,
	      default: '确认'
	    }
	  },
	  methods: {
	    handleWrapperClick: function handleWrapperClick(e) {
	      var wrapperEl = this.$refs.popup;
	      if (wrapperEl === e.target) _manager2.default.handleOverlayClick();
	    },
	    cancel: function cancel() {
	      this.$emit('close');
	      this.$emit('cancal');
	    },
	    ok: function ok() {
	      this.$emit('close');
	      this.$emit('ok');
	    }
	  }
	};

/***/ }),
/* 348 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    titleText: ''
	  }
	};

/***/ }),
/* 349 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    title: {
	      type: String,
	      default: ''
	    }
	  }
	};

/***/ }),
/* 350 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    title: String,
	    rightText: String,
	    showClickIcon: {
	      type: Boolean,
	      default: true
	    }
	  },
	  data: function data() {
	    return {};
	  },
	  mounted: function mounted() {},
	
	  methods: {
	    handleClick: function handleClick(i) {
	      this.$emit('click', i);
	    }
	  }
	};

/***/ }),
/* 351 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    value: {
	      type: String
	    },
	    hint: {
	      type: String
	    },
	    rightText: {
	      type: String
	    },
	    type: {
	      type: String,
	      default: 'text'
	    },
	    rightStyle: {
	      type: String,
	      default: 'normal'
	    }
	  },
	  data: function data() {
	    return {
	      inputValue: ''
	    };
	  },
	
	  computed: {
	    buttonClass: function buttonClass() {
	      return {
	        'disabled': this.disabled,
	        'primary': this.primary,
	        'secondary': this.secondary,
	        'default': this.default,
	        'full-width': this.fullWidth
	      };
	    }
	  },
	  watch: {
	    value: function value(val) {
	      this.inputValue = val;
	    },
	    inputValue: function inputValue(val) {
	      this.$emit('input', val);
	    }
	  },
	  methods: {
	    handleInput: function handleInput(val) {
	      this.value = val.target ? val.target.value : val;
	    }
	  }
	};

/***/ }),
/* 352 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'mu-overlay',
	  props: {
	    show: {
	      type: Boolean,
	      default: false
	    },
	    fixed: {
	      type: Boolean,
	      default: false
	    },
	    onClick: {
	      type: Function
	    },
	    opacity: {
	      type: Number,
	      default: 0.4
	    },
	    color: {
	      type: String,
	      default: '#000'
	    },
	    zIndex: {
	      type: Number
	    }
	  },
	  computed: {
	    overlayStyle: function overlayStyle() {
	      return {
	        'opacity': this.opacity,
	        'background-color': this.color,
	        'position': this.fixed ? 'fixed' : '',
	        'z-index': this.zIndex
	      };
	    }
	  },
	  methods: {
	    prevent: function prevent(event) {
	      event.preventDefault();
	      event.stopPropagation();
	    },
	    handleClick: function handleClick() {
	      if (this.onClick) {
	        this.onClick();
	      }
	    }
	  }
	};

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _right_arrow = __webpack_require__(647);
	
	var _right_arrow2 = _interopRequireDefault(_right_arrow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    leftText: {
	      type: String,
	      required: true
	    },
	    leftColor: {
	      type: String,
	      default: '#363636'
	    },
	    rightText: {
	      type: String
	    },
	    rightColor: {
	      type: String,
	      default: '#31c27c'
	    },
	    rightArraw: {
	      type: Boolean,
	      default: false
	    },
	    divide: {
	      type: Boolean,
	      default: true
	    }
	  },
	  data: function data() {
	    return {
	      rightArrPic: _right_arrow2.default
	    };
	  }
	};

/***/ }),
/* 354 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    leftText: {
	      type: String,
	      required: true
	    },
	    leftColor: {
	      type: String,
	      default: '#363636'
	    },
	    middleText: {
	      type: String
	    },
	    middleColor: {
	      type: String,
	      default: '#888888'
	    },
	    rightText: {
	      type: String
	    },
	    rightColor: {
	      type: String,
	      default: '#31c27c'
	    },
	    rightArrowColor: {
	      type: String,
	      default: '#A0A1A3'
	    },
	    divide: {
	      type: Boolean,
	      default: true
	    },
	    singLine: {
	      type: Boolean,
	      default: false
	    },
	    rightArraw: {
	      type: Boolean,
	      default: false
	    }
	  }
	};

/***/ }),
/* 355 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    leftText: {
	      type: String,
	      required: true
	    },
	    leftColor: {
	      type: String,
	      default: '#363636'
	    },
	    divide: {
	      type: Boolean,
	      default: true
	    }
	  },
	  data: function data() {
	    return {};
	  }
	};

/***/ }),
/* 356 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    mainText: {
	      type: String,
	      required: true
	    },
	    secondText: {
	      type: String,
	      required: false
	    },
	    rightText: {
	      type: String,
	      required: false
	    },
	    rightColor: {
	      type: String,
	      default: '#31c27c'
	    },
	    rightArrowColor: {
	      type: String,
	      default: '#A0A1A3'
	    },
	    rightArraw: {
	      type: Boolean,
	      default: false
	    }
	  }
	};

/***/ }),
/* 357 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    leftText: {
	      type: String,
	      required: true
	    },
	    imgUrl: {
	      type: String
	    },
	    middleText: {
	      type: String
	    },
	    rightText: {
	      type: String
	    }
	  }
	};

/***/ }),
/* 358 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {};

/***/ }),
/* 359 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    rightText: {
	      type: String
	    }
	  }
	};

/***/ }),
/* 360 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    text: ''
	  }
	};

/***/ }),
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    isSuccess: undefined,
	    tip: ''
	  }
	};

/***/ }),
/* 365 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    titleText: {
	      type: String,
	      default: '暂无数据'
	    }
	  }
	};

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(60);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    order: Object
	  },
	  computed: {
	    buttons: function buttons() {
	      if (this.order.baseOrderViewStatus === 'NOT_PAY') {
	        return [{ text: '付款', code: 'pay' }, { text: '取消订单', code: 'delete', secondy: true }];
	      }
	      if (this.order.baseOrderViewStatus === 'NOT_CONSUME') {
	        return [{ text: '去取餐', code: 'getFood' }, { text: '取消订单', code: 'delete', secondy: true }];
	      }
	      if (this.order.baseOrderViewStatus === 'CONSUMED') {
	        return [{ text: '评价', code: 'evaluate' }];
	      }
	    }
	  },
	  data: function data() {
	    return {
	      resource: window.resource
	    };
	  },
	
	  methods: {
	    formatDateByDate: _utils2.default.formatDateByDate,
	    formatPrice: _utils2.default.formatPrice,
	    handleClick: function handleClick(c) {
	      this.$emit('buttonClick', { order: this.order, orderId: this.order.orderId, code: c });
	    }
	  }
	};

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Periodname = __webpack_require__(642);
	
	var _Periodname2 = _interopRequireDefault(_Periodname);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    periodName: String,
	    dishes: Array,
	    status: String,
	    imgUrl: String,
	    index: Number,
	    hallName: String
	  },
	  data: function data() {
	    return {
	      noPeriodPic: _Periodname2.default
	    };
	  },
	
	  computed: {
	    statusClass: function statusClass() {
	      if (this.status === 'Ordered') return 'status-ordered';
	      if (this.status === 'NotPayed') return 'status-not-payed';
	      if (this.status === 'during') return 'status-during-order';
	      return 'status-unorder';
	    }
	  },
	  methods: {
	    getStatusText: function getStatusText(status) {
	      if (status === 'Ordered') return '已点';
	      if (status === 'NotPayed') return '未支付';
	      if (status === 'during') return '继续点';
	      return '未预定';
	    },
	    handleClick: function handleClick(e) {
	      this.$emit('click', e);
	    },
	    imgColor: function imgColor(index) {
	      var classes = ['#f9bdbb', '#e1bee7', '#a3e9a4', '#d0d9ff'];
	      return classes[index % 4];
	    }
	  }
	};

/***/ }),
/* 368 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    name: {
	      type: String,
	      required: true
	    },
	    employeeNo: {
	      type: String
	    },
	    companyName: {
	      type: String
	    }
	  }
	};

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _qrImage = __webpack_require__(631);
	
	var _qrImage2 = _interopRequireDefault(_qrImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    qrString: String,
	    title: String,
	    disabled: Boolean,
	    status: String
	  },
	  data: function data() {
	    return {};
	  },
	
	  computed: {
	    qrImg: function qrImg() {
	      return _qrImage2.default.imageSync(this.qrString, { type: 'svg' });
	    }
	  },
	  methods: {}
	};

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _qrcode = __webpack_require__(114);
	
	var _qrcode2 = _interopRequireDefault(_qrcode);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      qrcode: _qrcode2.default
	    };
	  },
	
	  methods: {
	    increment: function increment(value) {
	      this.$emit('click', value);
	    },
	    click: function click() {
	      this.increment('qrcode-tip');
	    }
	  }
	};

/***/ }),
/* 371 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    value: '',
	    name: '',
	    nameString: ''
	  },
	  methods: {
	    click: function click() {
	      this.$emit('input', this.name);
	    },
	    getOuterClass: function getOuterClass() {
	      if (this.$slots.icon || this.$slots.balance) {
	        return 'cell';
	      } else {
	        return 'cell-narrow';
	      }
	    }
	  }
	};

/***/ }),
/* 372 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  data: function data() {
	    return {};
	  },
	
	  props: {
	    title: String,
	    color: String
	  },
	  watch: {
	    title: function title() {
	      this.reDraw();
	    }
	  },
	  mounted: function mounted() {
	    this.reDraw();
	  },
	
	  methods: {
	    reDraw: function reDraw() {
	      var canvas = document.getElementById('canvas');
	      var context = canvas.getContext('2d');
	      canvas.width = canvas.width;
	      context.scale(1.6, 0.8);
	      var text = this.title;
	
	      var width = canvas.width * 0.5;
	      var height = canvas.height * 0.5;
	      context.rotate(-20 * Math.PI / 180);
	      context.translate(-width / 2, height / 2);
	      context.lineWidth = 1;
	      context.strokeStyle = this.color;
	      context.beginPath();
	      context.arc(width, height, width * 0.45, 0, Math.PI * 2);
	      context.stroke();
	      context.fillStyle = '#ffffff';
	      context.fill();
	      context.lineWidth = 1;
	      context.strokeStyle = this.color;
	      context.beginPath();
	      context.arc(width, height, width * 0.35, 0, Math.PI * 2);
	      context.stroke();
	
	      var fiveStarR = width * 0.3;
	      for (var i = 0; i < 20; i++) {
	        var rA = Math.PI / 8.0 * i;
	        var rx = width - fiveStarR * Math.cos(rA);
	        var ry = height - fiveStarR * Math.sin(rA);
	        this.create5star(context, rx, ry, 3, this.color, rA - Math.PI / 2);
	      }
	
	      this.drawRoundedRect(context, this.color, 'white', width * 0.5, width * 0.36, width, width / 3.5, 10);
	      context.font = '28px Helvetica';
	      context.textBaseline = 'middle';
	      context.textAlign = 'center';
	      context.lineWidth = 1;
	      context.strokeStyle = this.color;
	      context.strokeText(text, width, width / 2);
	    },
	    create5star: function create5star(context, sx, sy, radius, color, rotato) {
	      context.save();
	      context.fillStyle = color;
	      context.translate(sx, sy);
	      context.rotate(Math.PI + rotato);
	      context.beginPath();
	      var dig = Math.PI / 5 * 4;
	      for (var i = 0; i < 5; i++) {
	        var x = Math.sin(i * dig);
	        var y = Math.cos(i * dig);
	        context.lineTo(x * radius, y * radius);
	      }
	      context.closePath();
	      context.stroke();
	      context.fill();
	      context.restore();
	    },
	    roundedRect: function roundedRect(context, cornerX, cornerY, width, height, cornerRadius) {
	      if (width > 0) {
	        context.moveTo(cornerX + cornerRadius, cornerY);
	      } else {
	        context.moveTo(cornerX - cornerRadius, cornerY);
	      }
	
	      context.arcTo(cornerX + width, cornerY, cornerX + width, cornerY + height, cornerRadius);
	      context.arcTo(cornerX + width, cornerY + height, cornerX, cornerY + height, cornerRadius);
	      context.arcTo(cornerX, cornerY + height, cornerX, cornerY, cornerRadius);
	      if (width > 0) {
	        context.arcTo(cornerX, cornerY, cornerX + cornerRadius, cornerY, cornerRadius);
	      } else {
	        context.arcTo(cornerX, cornerY, cornerX - cornerRadius, cornerY, cornerRadius);
	      }
	    },
	    drawRoundedRect: function drawRoundedRect(context, strokeStyle, fillStyle, cornerX, cornerY, width, height, cornerRadius) {
	      context.save();
	      context.beginPath();
	      this.roundedRect(context, cornerX, cornerY, width, height, cornerRadius);
	      context.strokeStyle = strokeStyle;
	      context.fillStyle = fillStyle;
	      context.closePath();
	      context.stroke();
	      context.fill();
	      context.restore();
	    }
	  }
	};

/***/ }),
/* 373 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    active1: true,
	    active2: false
	  },
	  methods: {
	    increment: function increment(value) {
	      this.$emit('click', value);
	    },
	    click1: function click1() {
	      this.increment('homePage');
	    },
	    click2: function click2() {
	      this.increment('my');
	    }
	  }
	};

/***/ }),
/* 374 */,
/* 375 */,
/* 376 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    text: {
	      type: String
	    }
	  }
	};

/***/ }),
/* 377 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    src: '',
	    content: ''
	  }
	};

/***/ }),
/* 378 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    titleText: ''
	  }
	};

/***/ }),
/* 379 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    text: ''
	  },
	  methods: {
	    close: function close() {
	      window.$app.$emit('closeToast');
	    }
	  }
	
	};

/***/ }),
/* 380 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    titles: Array,
	    defaultValue: {
	      type: Number,
	      default: 0
	    }
	  },
	  data: function data() {
	    return {
	      value: undefined
	    };
	  },
	  mounted: function mounted() {
	    this.value = this.defaultValue;
	  },
	
	  methods: {
	    handleClick: function handleClick(i) {
	      if (this.value !== i) {
	        this.value = i;
	        this.$emit('change', i);
	      }
	    }
	  }
	};

/***/ }),
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(12);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(11);
	
	var _homepage = __webpack_require__(90);
	
	var _mixin = __webpack_require__(5);
	
	var _mixin2 = _interopRequireDefault(_mixin);
	
	var _bill2x = __webpack_require__(643);
	
	var _bill2x2 = _interopRequireDefault(_bill2x);
	
	var _ordering2x = __webpack_require__(646);
	
	var _ordering2x2 = _interopRequireDefault(_ordering2x);
	
	var _takemeal2x = __webpack_require__(648);
	
	var _takemeal2x2 = _interopRequireDefault(_takemeal2x);
	
	var _api = __webpack_require__(10);
	
	var _api2 = _interopRequireDefault(_api);
	
	var _qrcodejs = __webpack_require__(633);
	
	var _qrcodejs2 = _interopRequireDefault(_qrcodejs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  mixins: [_mixin2.default],
	  data: function data() {
	    return {
	      billImg: _bill2x2.default,
	      orderingImg: _ordering2x2.default,
	      takemealImg: _takemeal2x2.default,
	      balance: '-',
	      link: '',
	      show: false,
	      hasCode: false,
	      qrcodeShow: false,
	      param: {
	        companyName: ''
	      },
	      leavePage: {
	        redirect: true,
	        pass: ['charge', 'month-bill', 'main', 'period-list', 'my-qr-code', 'personal-center', 'order-list'],
	        to: 'main'
	      }
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({ user: function user(state) {
	      return state.user;
	    }, banners: function banners(state) {
	      return state.homepage.banners;
	    } }), {
	    buttonDiasbled: function buttonDiasbled() {
	      return !this.validateAll(this.param).valid;
	    },
	    isFoxconn: function isFoxconn() {
	      return this.user.companyId.toString() === '24' & this.formatDate(Date.now()) === '2017-11-09';
	    }
	  }),
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)([_homepage.GET_HOMEPAGE]), {
	    recharge: function recharge() {
	      if (!this.user.phoneNumber) {
	        this.$router.push("/login");
	        return;
	      }
	      if (!this.user.paymentCode) {
	        this.showToast("暂无缴费项目编号，请联系相关银行");
	        return;
	      }
	      this.show = true;
	      this.qrcode('https://enjoy.abchina.com/jf-web/epayItem?code=' + this.user.paymentCode + '&userInput=%7B%22input1%22%3A%22' + this.user.phoneNumber + '%22%2C%22input2%22%3A%22100%22%7D&showBill=0');
	    },
	    bannerClick: function bannerClick(e) {
	      var url = this.banners[e].url;
	      if (url && url.length > 0) {
	        location.href = url;
	      }
	    },
	    tabClick: function tabClick(type) {
	      if (type === 'my') {
	        this.$router.push('personal-center');
	      }
	    },
	    qrcodeClick: function qrcodeClick() {
	      this.qrcodeShow = false;
	      sessionStorage.setItem('qrcode_notshow', 1);
	    },
	    subscribestatus: function subscribestatus() {
	      var _this = this;
	
	      if (this.user.openId) {
	        _api2.default.subscribestatus(this.user).then(function (data) {
	          if (data.subscribed) {
	            sessionStorage.setItem('qrcode_notshow', 1);
	            _this.qrcodeShow = false;
	          } else {
	            sessionStorage.setItem('qrcode_notshow', 0);
	            _this.qrcodeShow = true;
	          }
	        }, function (data) {
	          sessionStorage.setItem('qrcode_notshow', 0);
	          _this.qrcodeShow = true;
	          _this.showToast(data);
	        });
	      }
	    },
	    qrcode: function qrcode(url) {
	      if (!this.hasCode) {
	        setTimeout(function () {
	          new _qrcodejs2.default('qrcode', {
	            width: 150,
	            height: 150,
	            text: url });
	        }, 0);
	      }
	      this.hasCode = true;
	    }
	  }),
	  created: function created() {
	    var path = window.localStorage.getItem('path-after-login');
	    if (path) {
	      this.$router.push({ path: path });
	      window.localStorage.setItem('path-after-login', null);
	    }
	  },
	  mounted: function mounted() {
	    var _this2 = this;
	
	    this.GET_HOMEPAGE(this.user).then(function (data) {}, function (data) {
	      _this2.showToast(data, 'cancel');
	    });
	
	    var notShow = sessionStorage.getItem('qrcode_notshow');
	    if (notShow === '0' || notShow === null) {
	      this.subscribestatus();
	    } else {
	      this.qrcodeShow = false;
	    }
	    this.setTitle('我的菜');
	    _api2.default.getBalance(this.user).then(function (data) {
	      _this2.balance = _this2.formatPrice(data.totalBalance, _this2.user.companyId);
	    }, function (data) {
	      _this2.showToast(data);
	    });
	  },
	  activated: function activated() {}
	};

/***/ }),
/* 397 */,
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(12);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _mixin = __webpack_require__(5);
	
	var _mixin2 = _interopRequireDefault(_mixin);
	
	var _vuex = __webpack_require__(11);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _records = __webpack_require__(59);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  mixins: [_mixin2.default],
	  data: function data() {
	    return {
	      monthTime: '',
	      showNOData: false
	    };
	  },
	  created: function created() {
	    this.setTitle('月账单');
	    this.SET_MONTHLY_REFRESH_LOCK(true);
	    this.REFRESH_MONTHLY_ORDERS(this.param());
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
	    user: function user(state) {
	      return state.user;
	    },
	    consumeOrders: function consumeOrders(state) {
	      return state.records.consumeOrders;
	    },
	    rechargeOrders: function rechargeOrders(state) {
	      return state.records.rechargeOrders;
	    },
	    calculatedData: function calculatedData(state) {
	      return state.records.monthDivideOrders;
	    } })),
	  mounted: function mounted() {
	    this.setTitle('月账单');
	    (0, _moment2.default)().local();
	  },
	
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)([_records.GET_CONSUME_ORDERS, _records.GET_RECHARGE_ORDERS, _records.SET_MONTHLY_REFRESH_LOCK, _records.REFRESH_MONTHLY_ORDERS]), {
	    detail: function detail(item) {
	      if (item.consumes.length === 0 && item.recharges.length === 0) {
	        this.showToast('该月无支出记录');
	        return;
	      }
	
	      $router.push({
	        path: '/a-month-bill',
	        query: { beginDate: item.begin }
	      });
	    },
	    getTimeRange: function getTimeRange(index) {
	      return this.getMonthlyRange(-6 * index, -(6 * (index - 1)));
	    },
	    param: function param() {
	      var _getTimeRange = this.getTimeRange(1),
	          start = _getTimeRange.start,
	          end = _getTimeRange.end;
	
	      return { user: this.user, start: start, end: end, page: 1 };
	    }
	  })
	};

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(12);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(11);
	
	var _api = __webpack_require__(10);
	
	var _api2 = _interopRequireDefault(_api);
	
	var _mixin = __webpack_require__(5);
	
	var _mixin2 = _interopRequireDefault(_mixin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  mixins: [_mixin2.default],
	  data: function data() {
	    return {
	      qrString: '',
	      timer: undefined
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({ user: function user(state) {
	      return state.user;
	    } })),
	  beforeDestroy: function beforeDestroy() {
	    clearInterval(this.timer);
	  },
	  created: function created() {
	    var _this = this;
	
	    this.setTitle('我的取餐码');
	    this.showLoading();
	    if (this.timer) {
	      clearInterval(this.timer);
	    }
	    this.timer = setInterval(function () {
	      _this.updateData();
	    }, 60 * 1000);
	    this.updateData();
	  },
	
	  methods: {
	    updateData: function updateData() {
	      var _this2 = this;
	
	      _api2.default.getPersonQrCodeString(this.user).then(function (data) {
	        _this2.qrString = data;
	        _this2.hideLoading();
	      }, function (data) {
	        _this2.hideLoading();
	        _this2.showToast(data, 'cancel');
	      });
	    }
	  }
	};

/***/ }),
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(12);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _mixin = __webpack_require__(5);
	
	var _mixin2 = _interopRequireDefault(_mixin);
	
	var _vuex = __webpack_require__(11);
	
	var _api = __webpack_require__(10);
	
	var _api2 = _interopRequireDefault(_api);
	
	var _ap = __webpack_require__(131);
	
	var _ap2 = _interopRequireDefault(_ap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  mixins: [_mixin2.default],
	  created: function created() {
	    this.setTitle('充值');
	    this.getBalance();
	  },
	  data: function data() {
	    return {
	      balance: '-',
	      selectedPayType: '',
	      cashDepositBalance: 0,
	      balanceTip: '',
	      rechargeSupports: [],
	      rechargeSupportDic: {},
	      showValue: '0',
	      tipMessage: '🙄',
	      dialog: {
	        open: false,
	        okText: '去充值',
	        cancelText: '再想想'
	      },
	      ap: _ap2.default
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({ user: function user(state) {
	      return state.user;
	    }, banners: function banners(state) {
	      return state.homepage.banners;
	    } }), {
	    rechargeValue: function rechargeValue() {
	      return parseFloat(this.showValue) * 100;
	    },
	    dialogContent: function dialogContent() {
	      var info = !this.user.employeeNo ? '\u624B\u673A\u53F7\uFF1A' + this.user.phoneNumber : '\u5DE5\u53F7\uFF1A' + this.user.employeeNo;
	      return '\u5411' + this.user.userName + '(' + info + ')\u8D26\u6237\u5145\u503C' + this.showValue + '\u5143';
	    },
	    isFoxconn: function isFoxconn() {
	      return this.user.companyId.toString() === '24' && this.formatDate(Date.now()) === '2017-11-09';
	    }
	  }),
	  watch: {
	    selectedPayType: function selectedPayType() {
	      var _this = this;
	
	      this.rechargeSupports.forEach(function (item) {
	        if (item.payType === _this.selectedPayType) {
	          _this.rechargeSupportDic = item;
	        }
	      });
	    }
	  },
	  methods: {
	    getBalance: function getBalance() {
	      var _this2 = this;
	
	      _api2.default.getBalance(this.user).then(function (data) {
	        _this2.balance = data.totalBalance;
	        _this2.rechargeSupports = data.rechargeSupports;
	        _this2.selectedPayType = _this2.rechargeSupports[0].payType;
	        _this2.rechargeSupportDic = _this2.rechargeSupports[0];
	
	        _this2.balanceTip = '\u8D26\u6237\u4F59\u989D: \u5305\u542B\u9910\u8865' + _this2.formatPrice(data.subsidyBalance ? data.subsidyBalance : 0) + ', \u8D60\u9001' + _this2.formatPrice(data.bonusPriorityBalance ? data.bonusPriorityBalance : 0);
	      }, function (data) {});
	    },
	    commit: function commit() {
	      if (this.rechargeValue === 0 || this.rechargeValue === undefined) {
	        this.tipMessage = '充值金额不能为0';
	        this.showToast(this.tipMessage);
	        return;
	      }
	
	      if (this.rechargeValue < this.rechargeSupportDic.minAllowedValue) {
	        if (this.rechargeSupportDic.minAllowedValue > 0) {
	          this.tipMessage = '\u6700\u4F4E\u5145\u503C\u91D1\u989D\u4E0D\u80FD\u4F4E\u4E8E' + this.formatPrice(this.rechargeSupportDic.minAllowedValue);
	          this.showToast(this.tipMessage);
	          return;
	        }
	      }
	
	      if (this.rechargeValue > this.maxAllowedValue) {
	        if (this.maxAllowedValue > 0) {
	          this.tipMessage = '\u6700\u9AD8\u5141\u8BB8\u5145\u503C' + this.formatPrice(this.rechargeSupportDic.maxAllowedValue);
	          this.showToast(this.tipMessage);
	          return;
	        }
	      }
	
	      if (this.balance > this.rechargeSupportDic.accountMaxAllowed || this.balance + this.rechargeValue > this.rechargeSupportDic.accountMaxAllowed) {
	        if (this.rechargeSupportDic.accountMaxAllowed > 0) {
	          this.tipMessage = '\u60A8\u5145\u503C\u540E\u8D26\u6237\u7684\u91D1\u989D\u8D85\u8FC7\u4E0A\u9650' + this.formatPrice(this.rechargeSupportDic.accountMaxAllowed);
	          this.showToast(this.tipMessage);
	          return;
	        }
	      }
	
	      if (this.cashDepositBalance > this.rechargeSupportDic.accountCashMaxAllowed || this.cashDepositBalance + this.rechargeValue > this.rechargeSupportDic.accountCashMaxAllowed) {
	        if (this.rechargeSupportDic.accountCashMaxAllowed > 0) {
	          this.tipMessage = '\u8D26\u6237\u7684\u73B0\u91D1\u91D1\u989D\u4E0D\u80FD\u8D85\u8FC7' + this.formatPrice(this.rechargeSupportDic.accountCashMaxAllowed);
	          this.showToast(this.tipMessage);
	          return;
	        }
	      }
	      this.recharge();
	    },
	    recharge: function recharge() {
	      var _this3 = this;
	
	      this.showLoading();
	      _api2.default.recharge(this.user, this.selectedPayType, this.rechargeValue).then(function (data) {
	        _api2.default.getPayInfo(_this3.user, data['orderId'], _this3.selectedPayType).then(function (data) {
	          _this3.hideLoading();
	          if (data.type === 'alipay') {
	            window._AP.pay(data.aliPayString);
	          } else if (data.type === 'weixinpay') {
	            window.wx.config({
	              debug: false,
	              appId: data.wxPayingForm.weConfig.wxId,
	              timestamp: data.wxPayingForm.weConfig.timestamp,
	              nonceStr: data.wxPayingForm.weConfig.nonceStr,
	              signature: data.wxPayingForm.weConfig.signature,
	              jsApiList: ['jsApiList'] });
	            wx.ready(function () {
	              wx.chooseWXPay({
	                timestamp: data.wxPayingForm.weData.weixinpay.timeStamp,
	                nonceStr: data.wxPayingForm.weData.weixinpay.nonceStr,
	                package: data.wxPayingForm.weData.weixinpay.package,
	                signType: data.wxPayingForm.weData.weixinpay.signType,
	                paySign: data.wxPayingForm.weData.weixinpay.paySign,
	                success: function success(res) {
	                  _this3.setTempParam({ payType: _this3.selectedPayType, price: _this3.rechargeValue });
	                  $router.push({
	                    path: '/pay-success'
	                  });
	                },
	                fail: function fail(res) {
	                  this.showToast(res);
	                },
	                cancel: function cancel(res) {
	                  this.showToast(res);
	                }
	              });
	            });
	          }
	        }, function (data) {
	          _this3.hideLoading();
	          _this3.showToast(data);
	        });
	      }, function (data) {
	        _this3.showToast(data);
	        _this3.hideLoading();
	      });
	    }
	  }
	};

/***/ }),
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mixin = __webpack_require__(5);
	
	var _mixin2 = _interopRequireDefault(_mixin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  mixins: [_mixin2.default],
	  data: function data() {
	    return {
	      data: {}
	    };
	  },
	  mounted: function mounted() {
	    this.setTitle('充值详情');
	    var param = this.getTempParam();
	    if (!param) {
	      this.showToast('参数错误');
	      this.delayBack();
	      return;
	    }
	    this.data = param;
	    this.setTitle('充值详情');
	  }
	};

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _header = __webpack_require__(747);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _button = __webpack_require__(739);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _dialog = __webpack_require__(745);
	
	var _dialog2 = _interopRequireDefault(_dialog);
	
	var _input = __webpack_require__(749);
	
	var _input2 = _interopRequireDefault(_input);
	
	var _tab = __webpack_require__(770);
	
	var _tab2 = _interopRequireDefault(_tab);
	
	var _dateSelector = __webpack_require__(742);
	
	var _dateSelector2 = _interopRequireDefault(_dateSelector);
	
	var _tile = __webpack_require__(774);
	
	var _tile2 = _interopRequireDefault(_tile);
	
	var _titleText = __webpack_require__(775);
	
	var _titleText2 = _interopRequireDefault(_titleText);
	
	var _order = __webpack_require__(763);
	
	var _order2 = _interopRequireDefault(_order);
	
	var _qrCode = __webpack_require__(766);
	
	var _qrCode2 = _interopRequireDefault(_qrCode);
	
	var _stamp = __webpack_require__(769);
	
	var _stamp2 = _interopRequireDefault(_stamp);
	
	var _message = __webpack_require__(761);
	
	var _message2 = _interopRequireDefault(_message);
	
	var _period = __webpack_require__(764);
	
	var _period2 = _interopRequireDefault(_period);
	
	var _topTab = __webpack_require__(777);
	
	var _topTab2 = _interopRequireDefault(_topTab);
	
	var _radio = __webpack_require__(768);
	
	var _radio2 = _interopRequireDefault(_radio);
	
	var _infoItem = __webpack_require__(748);
	
	var _infoItem2 = _interopRequireDefault(_infoItem);
	
	var _cells = __webpack_require__(740);
	
	var _cells2 = _interopRequireDefault(_cells);
	
	var _itemCell = __webpack_require__(752);
	
	var _itemCell2 = _interopRequireDefault(_itemCell);
	
	var _itemTotalPrice = __webpack_require__(757);
	
	var _itemTotalPrice2 = _interopRequireDefault(_itemTotalPrice);
	
	var _itemStaticsTitle = __webpack_require__(756);
	
	var _itemStaticsTitle2 = _interopRequireDefault(_itemStaticsTitle);
	
	var _itemStaticsDish = __webpack_require__(755);
	
	var _itemStaticsDish2 = _interopRequireDefault(_itemStaticsDish);
	
	var _itemAlignTextCell = __webpack_require__(751);
	
	var _itemAlignTextCell2 = _interopRequireDefault(_itemAlignTextCell);
	
	var _personalInfoCard = __webpack_require__(765);
	
	var _personalInfoCard2 = _interopRequireDefault(_personalInfoCard);
	
	var _charge = __webpack_require__(741);
	
	var _charge2 = _interopRequireDefault(_charge);
	
	var _textButton = __webpack_require__(773);
	
	var _textButton2 = _interopRequireDefault(_textButton);
	
	var _itemDoubleLine = __webpack_require__(754);
	
	var _itemDoubleLine2 = _interopRequireDefault(_itemDoubleLine);
	
	var _banner = __webpack_require__(738);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	var _toast = __webpack_require__(776);
	
	var _toast2 = _interopRequireDefault(_toast);
	
	var _loading = __webpack_require__(758);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _noData = __webpack_require__(762);
	
	var _noData2 = _interopRequireDefault(_noData);
	
	var _itemCustomRight = __webpack_require__(753);
	
	var _itemCustomRight2 = _interopRequireDefault(_itemCustomRight);
	
	var _dialogSelector = __webpack_require__(744);
	
	var _dialogSelector2 = _interopRequireDefault(_dialogSelector);
	
	var _dialogCustom = __webpack_require__(743);
	
	var _dialogCustom2 = _interopRequireDefault(_dialogCustom);
	
	var _attention = __webpack_require__(737);
	
	var _attention2 = _interopRequireDefault(_attention);
	
	var _qrcodeTip = __webpack_require__(767);
	
	var _qrcodeTip2 = _interopRequireDefault(_qrcodeTip);
	
	var _foxconn = __webpack_require__(746);
	
	var _foxconn2 = _interopRequireDefault(_foxconn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  loading: _loading2.default,
	  toast: _toast2.default,
	  banner: _banner2.default,
	  'foxconn': _foxconn2.default,
	  'qrcode-tip': _qrcodeTip2.default,
	  'no-data': _noData2.default,
	  'text-button': _textButton2.default,
	  charge: _charge2.default,
	  'item-double-line': _itemDoubleLine2.default,
	  'item-statics-dish': _itemStaticsDish2.default,
	  'item-statics-title': _itemStaticsTitle2.default,
	  'item-total-price': _itemTotalPrice2.default,
	  'item-cell': _itemCell2.default,
	  cells: _cells2.default,
	  header: _header2.default,
	  button: _button2.default,
	  stamp: _stamp2.default,
	  'date-selector': _dateSelector2.default,
	  'qr-code': _qrCode2.default,
	  tab: _tab2.default,
	  'top-tab': _topTab2.default,
	  'info-item': _infoItem2.default,
	  'item-align-text-cell': _itemAlignTextCell2.default,
	  tile: _tile2.default,
	  dialog: _dialog2.default,
	  'personal-info-card': _personalInfoCard2.default,
	  input: _input2.default,
	  'title-text': _titleText2.default,
	  order: _order2.default,
	  message: _message2.default,
	  period: _period2.default,
	  radio: _radio2.default,
	  'item-custom-right': _itemCustomRight2.default,
	  'dialog-selector': _dialogSelector2.default,
	  'dialog-custom': _dialogCustom2.default,
	  'attention': _attention2.default
	};

/***/ }),
/* 419 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var zIndex = 20141223;
	
	var getZIndex = exports.getZIndex = function getZIndex() {
	  return zIndex++;
	};
	
	var getDOM = exports.getDOM = function getDOM(dom) {
	  if (dom.nodeType === 3) {
	    dom = dom.nextElementSibling || dom.nextSibling;
	    getDOM(dom);
	  }
	  return dom;
	};

/***/ }),
/* 420 */,
/* 421 */,
/* 422 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  getKeys: function getKeys(str) {
	    return str.split(',');
	  },
	
	  keysToStr: function keysToStr(arr) {
	    return arr.joni(',');
	  },
	  orderStatus: {
	    'NOT_PAY': '未支付',
	    'NOT_CONSUME': '未消费',
	    'CONSUMED': '已消费',
	    'REFUNDING': '退款中',
	    'CANCELED': '已取消',
	    'REFUND': '已退款',
	    'COMMENTED': '已评价',
	    'CLOSED': '已关闭'
	  },
	  rechargeKind: {
	    label: '充值来源',
	    values: {
	      0: '普通',
	      1: '现金',
	      2: '餐补',
	      3: '微信',
	      4: '支付宝',
	      6: '赠送',
	      8: '农行掌银'
	    }
	  },
	  rechargeType: {
	    label: '充值类型',
	    values: {
	      '-1': '冲红',
	      1: '充值',
	      2: '冲正',
	      3: '月底清零'
	    }
	  },
	  payType: {
	    'alipay': '支付宝',
	    'weixinpay': '微信支付',
	    'common': '公司卡支付',
	    'unkonwn': '暂无'
	  },
	  tagType: {
	    label: '标签基本类型',
	    values: {
	      1: '普通标签',
	      2: '营养标签'
	    }
	  },
	  limitType: {
	    label: '标签限制提醒类型',
	    values: {
	      0: '无限制无提醒',
	      1: '限制',
	      3: '提醒'
	    }
	  },
	  checkType: {
	    label: '标签范围',
	    values: {
	      1: '单品',
	      2: '范围'
	    }
	  },
	  supportMode: {
	    label: '配送方式',
	    values: {
	      'common': '食堂就餐',
	      'pickup': '食堂自提',
	      'distribution': '配送上门'
	    }
	  },
	  orderMode: {
	    'common': '堂食',
	    'distribution': '配送',
	    'pickup': '自提'
	  }
	};

/***/ }),
/* 423 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  employeeNo: {
	    required: true,
	    regex: /.+/,
	    tips: '请输入员工号'
	  },
	  userName: {
	    required: true,
	    regex: /.+/,
	    tips: '请输入员工姓名'
	  },
	  password: {
	    required: true,
	    regex: /.{6,}/,
	    tips: '请输入至少6位密码'
	  },
	  oldPwd: {
	    required: true,
	    regex: /.{6,}/,
	    tips: '请输入至少6位密码'
	  },
	  newPwd1: {
	    required: true,
	    regex: /.{6,}/,
	    tips: '请输入至少6位密码'
	  },
	  newPwd2: {
	    required: true,
	    regex: /.{6,}/,
	    tips: '请输入至少6位密码'
	  },
	  phone: {
	    required: true,
	    regex: /^1\d{10}$/,
	    tips: '请输入首位是1且11位的手机号'
	  },
	  Verification: {
	    required: true,
	    regex: /^\d{6}$/,
	    tips: '请输入6位的验证码'
	  }
	};

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _App = __webpack_require__(736);
	
	var _App2 = _interopRequireDefault(_App);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = [{
	  path: '/',
	  component: _App2.default,
	  children: [{
	    path: '/main',
	    meta: { keepAlive: false },
	    component: __webpack_require__(791)
	  }, {
	    path: '/',
	    meta: { auth: false },
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(26, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(785)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: '/evaluate',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(19, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(797)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: '/oauth',
	    meta: { auth: false },
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(25, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(787)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: '/login',
	    meta: { auth: false },
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(0, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(317)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: '/confirm-info',
	    meta: { auth: false },
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(5, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(784)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: '/register',
	    meta: { auth: false },
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(23, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(789)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: '/bind-card',
	    meta: { auth: false },
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(29, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(780)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: '/new-creat',
	    meta: { auth: false },
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(4, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(786)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: '/card-new-creat',
	    meta: { auth: false },
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(6, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(781)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: '/company-name',
	    meta: { auth: false },
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(27, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(783)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: '/personal-center',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(11, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(808)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: '/personal-info',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(10, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(809)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: '/quick-pay',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(8, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(811)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: '/quick-pay-bill',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(9, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(810)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: '/binding-phone',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(13, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(805)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: '/dish-statistics',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(30, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(779)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: '/month-bill',
	    component: __webpack_require__(793)
	  }, {
	    path: '/change-password',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(3, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(806)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: '/order-detail',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(18, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(798)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: '/period-list',
	    meta: { keepAlive: true },
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(14, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(804)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: '/menu',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(2, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(792)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: '/order-list',
	    meta: { keepAlive: true },
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(7, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(799)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: '/confirm-order',
	    meta: { keepAlive: true },
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(21, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(795)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: '/select-delivery-address',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(15, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(803)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: '/delivery-address-detail',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(20, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(796)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: '/pay',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(16, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(801)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: '/pay-success',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(17, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(800)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: '/my-qr-code',
	    component: __webpack_require__(794)
	  }, {
	    path: '/charge',
	    component: __webpack_require__(802)
	  }, {
	    path: '/a-month-bill',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(31, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(778)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: '/recharge-detail',
	    component: __webpack_require__(812)
	  }, {
	    path: '/open-register',
	    meta: { auth: false },
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(24, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(788)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: '/association',
	    meta: { auth: false },
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(1, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(316)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: '/association',
	    meta: { auth: false },
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(1/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(316)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: '/change-card',
	    meta: { auth: false },
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(28, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(782)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: '/verification-phone',
	    meta: { auth: false },
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(22, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(790)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: '/company-qr-code',
	    meta: { auth: false },
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(12, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(807)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: '/',
	    meta: { auth: false },
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(0/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(317)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }]
	}];

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(16);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(11);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _user = __webpack_require__(49);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _period = __webpack_require__(58);
	
	var _period2 = _interopRequireDefault(_period);
	
	var _homepage = __webpack_require__(90);
	
	var _homepage2 = _interopRequireDefault(_homepage);
	
	var _records = __webpack_require__(59);
	
	var _records2 = _interopRequireDefault(_records);
	
	var _deliveryAddress = __webpack_require__(89);
	
	var _deliveryAddress2 = _interopRequireDefault(_deliveryAddress);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	
	exports.default = new _vuex2.default.Store({
	  strict: ("production") !== 'production',
	  modules: {
	    user: _user2.default,
	    period: _period2.default,
	    homepage: _homepage2.default,
	    records: _records2.default,
	    deliveryAddress: _deliveryAddress2.default
	  }
	});

/***/ }),
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 531 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 532 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 533 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 534 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 535 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 536 */,
/* 537 */,
/* 538 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 539 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 540 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 546 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 547 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 548 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 549 */,
/* 550 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 551 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 552 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 558 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 559 */,
/* 560 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 561 */,
/* 562 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 563 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 564 */,
/* 565 */,
/* 566 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 567 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 568 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 569 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 570 */,
/* 571 */,
/* 572 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 573 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 574 */,
/* 575 */,
/* 576 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 577 */,
/* 578 */,
/* 579 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 580 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 581 */,
/* 582 */,
/* 583 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 584 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 585 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 586 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 587 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 593 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 594 */,
/* 595 */,
/* 596 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 597 */,
/* 598 */,
/* 599 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 600 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 601 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 602 */,
/* 603 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 604 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 605 */,
/* 606 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 607 */,
/* 608 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 609 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 610 */,
/* 611 */,
/* 612 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 613 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 614 */,
/* 615 */,
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 153,
		"./af.js": 153,
		"./ar": 160,
		"./ar-dz": 154,
		"./ar-dz.js": 154,
		"./ar-kw": 155,
		"./ar-kw.js": 155,
		"./ar-ly": 156,
		"./ar-ly.js": 156,
		"./ar-ma": 157,
		"./ar-ma.js": 157,
		"./ar-sa": 158,
		"./ar-sa.js": 158,
		"./ar-tn": 159,
		"./ar-tn.js": 159,
		"./ar.js": 160,
		"./az": 161,
		"./az.js": 161,
		"./be": 162,
		"./be.js": 162,
		"./bg": 163,
		"./bg.js": 163,
		"./bn": 164,
		"./bn.js": 164,
		"./bo": 165,
		"./bo.js": 165,
		"./br": 166,
		"./br.js": 166,
		"./bs": 167,
		"./bs.js": 167,
		"./ca": 168,
		"./ca.js": 168,
		"./cs": 169,
		"./cs.js": 169,
		"./cv": 170,
		"./cv.js": 170,
		"./cy": 171,
		"./cy.js": 171,
		"./da": 172,
		"./da.js": 172,
		"./de": 175,
		"./de-at": 173,
		"./de-at.js": 173,
		"./de-ch": 174,
		"./de-ch.js": 174,
		"./de.js": 175,
		"./dv": 176,
		"./dv.js": 176,
		"./el": 177,
		"./el.js": 177,
		"./en-au": 178,
		"./en-au.js": 178,
		"./en-ca": 179,
		"./en-ca.js": 179,
		"./en-gb": 180,
		"./en-gb.js": 180,
		"./en-ie": 181,
		"./en-ie.js": 181,
		"./en-nz": 182,
		"./en-nz.js": 182,
		"./eo": 183,
		"./eo.js": 183,
		"./es": 185,
		"./es-do": 184,
		"./es-do.js": 184,
		"./es.js": 185,
		"./et": 186,
		"./et.js": 186,
		"./eu": 187,
		"./eu.js": 187,
		"./fa": 188,
		"./fa.js": 188,
		"./fi": 189,
		"./fi.js": 189,
		"./fo": 190,
		"./fo.js": 190,
		"./fr": 193,
		"./fr-ca": 191,
		"./fr-ca.js": 191,
		"./fr-ch": 192,
		"./fr-ch.js": 192,
		"./fr.js": 193,
		"./fy": 194,
		"./fy.js": 194,
		"./gd": 195,
		"./gd.js": 195,
		"./gl": 196,
		"./gl.js": 196,
		"./gom-latn": 197,
		"./gom-latn.js": 197,
		"./he": 198,
		"./he.js": 198,
		"./hi": 199,
		"./hi.js": 199,
		"./hr": 200,
		"./hr.js": 200,
		"./hu": 201,
		"./hu.js": 201,
		"./hy-am": 202,
		"./hy-am.js": 202,
		"./id": 203,
		"./id.js": 203,
		"./is": 204,
		"./is.js": 204,
		"./it": 205,
		"./it.js": 205,
		"./ja": 206,
		"./ja.js": 206,
		"./jv": 207,
		"./jv.js": 207,
		"./ka": 208,
		"./ka.js": 208,
		"./kk": 209,
		"./kk.js": 209,
		"./km": 210,
		"./km.js": 210,
		"./kn": 211,
		"./kn.js": 211,
		"./ko": 212,
		"./ko.js": 212,
		"./ky": 213,
		"./ky.js": 213,
		"./lb": 214,
		"./lb.js": 214,
		"./lo": 215,
		"./lo.js": 215,
		"./lt": 216,
		"./lt.js": 216,
		"./lv": 217,
		"./lv.js": 217,
		"./me": 218,
		"./me.js": 218,
		"./mi": 219,
		"./mi.js": 219,
		"./mk": 220,
		"./mk.js": 220,
		"./ml": 221,
		"./ml.js": 221,
		"./mr": 222,
		"./mr.js": 222,
		"./ms": 224,
		"./ms-my": 223,
		"./ms-my.js": 223,
		"./ms.js": 224,
		"./my": 225,
		"./my.js": 225,
		"./nb": 226,
		"./nb.js": 226,
		"./ne": 227,
		"./ne.js": 227,
		"./nl": 229,
		"./nl-be": 228,
		"./nl-be.js": 228,
		"./nl.js": 229,
		"./nn": 230,
		"./nn.js": 230,
		"./pa-in": 231,
		"./pa-in.js": 231,
		"./pl": 232,
		"./pl.js": 232,
		"./pt": 234,
		"./pt-br": 233,
		"./pt-br.js": 233,
		"./pt.js": 234,
		"./ro": 235,
		"./ro.js": 235,
		"./ru": 236,
		"./ru.js": 236,
		"./sd": 237,
		"./sd.js": 237,
		"./se": 238,
		"./se.js": 238,
		"./si": 239,
		"./si.js": 239,
		"./sk": 240,
		"./sk.js": 240,
		"./sl": 241,
		"./sl.js": 241,
		"./sq": 242,
		"./sq.js": 242,
		"./sr": 244,
		"./sr-cyrl": 243,
		"./sr-cyrl.js": 243,
		"./sr.js": 244,
		"./ss": 245,
		"./ss.js": 245,
		"./sv": 246,
		"./sv.js": 246,
		"./sw": 247,
		"./sw.js": 247,
		"./ta": 248,
		"./ta.js": 248,
		"./te": 249,
		"./te.js": 249,
		"./tet": 250,
		"./tet.js": 250,
		"./th": 251,
		"./th.js": 251,
		"./tl-ph": 252,
		"./tl-ph.js": 252,
		"./tlh": 253,
		"./tlh.js": 253,
		"./tr": 254,
		"./tr.js": 254,
		"./tzl": 255,
		"./tzl.js": 255,
		"./tzm": 257,
		"./tzm-latn": 256,
		"./tzm-latn.js": 256,
		"./tzm.js": 257,
		"./uk": 258,
		"./uk.js": 258,
		"./ur": 259,
		"./ur.js": 259,
		"./uz": 261,
		"./uz-latn": 260,
		"./uz-latn.js": 260,
		"./uz.js": 261,
		"./vi": 262,
		"./vi.js": 262,
		"./x-pseudo": 263,
		"./x-pseudo.js": 263,
		"./yo": 264,
		"./yo.js": 264,
		"./zh-cn": 265,
		"./zh-cn.js": 265,
		"./zh-hk": 266,
		"./zh-hk.js": 266,
		"./zh-tw": 267,
		"./zh-tw.js": 267
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 616;


/***/ }),
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 643 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 644 */,
/* 645 */,
/* 646 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 647 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAyCAYAAABPq7vSAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAACXBIWXMAAAsTAAALEwEAmpwYAAABWWlUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iWE1QIENvcmUgNS40LjAiPgogICA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPgogICAgICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIgogICAgICAgICAgICB4bWxuczp0aWZmPSJodHRwOi8vbnMuYWRvYmUuY29tL3RpZmYvMS4wLyI+CiAgICAgICAgIDx0aWZmOk9yaWVudGF0aW9uPjE8L3RpZmY6T3JpZW50YXRpb24+CiAgICAgIDwvcmRmOkRlc2NyaXB0aW9uPgogICA8L3JkZjpSREY+CjwveDp4bXBtZXRhPgpMwidZAAACZklEQVRYCb3YzY7SUBQH8La0Jc6OxwAiJIbFfJghExN9AN9GN0R9qVkYxY1OQpRveALYsDTKtED9/5u5DUKB9n5wE1IIl/Obc8+d25NaURTZFsZwOPyI1xu+73Q6Hq/GBqAP8/k8GgwGy36/f0XIGDoajT7NZjNif6bTaQQwNIk6WNKHxWKxdl33WRiGj77vu0jwG9FGoxHqzjSuH4I3bdv+AtRerVaPnucVgyBYAb6t1WrfiRLnUqsOh8EQtA3sDliEa9FkpnGGIoPJZNIEajTTGOQynQt1RE3EBimXy21sJGPLm2QoYJFp2kZCbUP8MU2VjbQHbi+vCTQVNIkeBE2hR0ET6ElQN5oJ1IlmBnWhuUAdaG5QFZUCVdDkLGWQPEOcvby17Z69uJ96uL+2x+PxpZgnYktnKAKcOnsLhcJtpVL5IeYpg4RFsJ2zN0CiPg/8bVQLuIs6jvMVmIU2JUbZrgB9Wa1WH7SB22iv17sE+hmvi81mQ8xdr9cR6vpKetMQODQQuIjv4tjYUBY+c2qIa6gtQ1FH9LevkdE9srNQvgBtp48l/YvP11jSrhZwG0Pge2aEJWSPy3aT2A2wX5ynDObB+D+pVMNTGDYMd2acGTEWUjrDLFi9Xv8p5hHjkAJFEG6QtJoxszRMClTBcoOqWC5QB5YZ1IVlAnViJ0Hd2FHQBHYQNIWlgiaxPdA09h94DiwBz4XF4DmxJEOZU58/lhkOHuy9RUuw1xYcu8XIQOI3fNb2vFQqsQdZPvUgS1OYQC0s6funJ4q/0VO+4BesbTJB55tWqxX3NUDfdbvdO6MYgv8Dk3ssq2DjcTsAAAAASUVORK5CYII="

/***/ }),
/* 648 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(4)(
	  /* script */
	  __webpack_require__(336),
	  /* template */
	  __webpack_require__(838),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(4)(
	  /* script */
	  __webpack_require__(337),
	  /* template */
	  __webpack_require__(864),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(545)
	
	var Component = __webpack_require__(4)(
	  /* script */
	  __webpack_require__(338),
	  /* template */
	  __webpack_require__(823),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(568)
	
	var Component = __webpack_require__(4)(
	  /* script */
	  __webpack_require__(339),
	  /* template */
	  __webpack_require__(847),
	  /* scopeId */
	  "data-v-503f4ac5",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(552)
	
	var Component = __webpack_require__(4)(
	  /* script */
	  __webpack_require__(340),
	  /* template */
	  __webpack_require__(830),
	  /* scopeId */
	  "data-v-1dbcd815",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(585)
	
	var Component = __webpack_require__(4)(
	  /* script */
	  __webpack_require__(341),
	  /* template */
	  __webpack_require__(865),
	  /* scopeId */
	  "data-v-709a0d1b",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(599)
	
	var Component = __webpack_require__(4)(
	  /* script */
	  __webpack_require__(342),
	  /* template */
	  __webpack_require__(879),
	  /* scopeId */
	  "data-v-90a84a10",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(601)
	
	var Component = __webpack_require__(4)(
	  /* script */
	  __webpack_require__(343),
	  /* template */
	  __webpack_require__(881),
	  /* scopeId */
	  "data-v-a07d10c6",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(593)
	
	var Component = __webpack_require__(4)(
	  /* script */
	  __webpack_require__(344),
	  /* template */
	  __webpack_require__(873),
	  /* scopeId */
	  "data-v-7b21d545",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(592)
	
	var Component = __webpack_require__(4)(
	  /* script */
	  __webpack_require__(345),
	  /* template */
	  __webpack_require__(872),
	  /* scopeId */
	  "data-v-7738f486",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(540)
	
	var Component = __webpack_require__(4)(
	  /* script */
	  __webpack_require__(346),
	  /* template */
	  __webpack_require__(818),
	  /* scopeId */
	  "data-v-0ab3ca2b",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(539)
	
	var Component = __webpack_require__(4)(
	  /* script */
	  __webpack_require__(347),
	  /* template */
	  __webpack_require__(817),
	  /* scopeId */
	  "data-v-08ace831",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(606)
	
	var Component = __webpack_require__(4)(
	  /* script */
	  __webpack_require__(348),
	  /* template */
	  __webpack_require__(886),
	  /* scopeId */
	  "data-v-a9f6b13c",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(573)
	
	var Component = __webpack_require__(4)(
	  /* script */
	  __webpack_require__(349),
	  /* template */
	  __webpack_require__(852),
	  /* scopeId */
	  "data-v-5dccba14",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(548)
	
	var Component = __webpack_require__(4)(
	  /* script */
	  __webpack_require__(350),
	  /* template */
	  __webpack_require__(826),
	  /* scopeId */
	  "data-v-15432479",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(596)
	
	var Component = __webpack_require__(4)(
	  /* script */
	  __webpack_require__(351),
	  /* template */
	  __webpack_require__(876),
	  /* scopeId */
	  "data-v-8998aa1e",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(608)
	
	var Component = __webpack_require__(4)(
	  /* script */
	  __webpack_require__(352),
	  /* template */
	  __webpack_require__(888),
	  /* scopeId */
	  "data-v-bf666cf8",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(604)
	
	var Component = __webpack_require__(4)(
	  /* script */
	  __webpack_require__(353),
	  /* template */
	  __webpack_require__(884),
	  /* scopeId */
	  "data-v-a88a18ae",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(566)
	
	var Component = __webpack_require__(4)(
	  /* script */
	  __webpack_require__(354),
	  /* template */
	  __webpack_require__(845),
	  /* scopeId */
	  "data-v-4914be83",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(538)
	
	var Component = __webpack_require__(4)(
	  /* script */
	  __webpack_require__(355),
	  /* template */
	  __webpack_require__(816),
	  /* scopeId */
	  "data-v-042c05e1",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(546)
	
	var Component = __webpack_require__(4)(
	  /* script */
	  __webpack_require__(356),
	  /* template */
	  __webpack_require__(824),
	  /* scopeId */
	  "data-v-1058ab5f",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(557)
	
	var Component = __webpack_require__(4)(
	  /* script */
	  __webpack_require__(357),
	  /* template */
	  __webpack_require__(835),
	  /* scopeId */
	  "data-v-2ce33ec3",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(550)
	
	var Component = __webpack_require__(4)(
	  /* script */
	  __webpack_require__(358),
	  /* template */
	  __webpack_require__(828),
	  /* scopeId */
	  "data-v-1b290102",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(587)
	
	var Component = __webpack_require__(4)(
	  /* script */
	  __webpack_require__(359),
	  /* template */
	  __webpack_require__(867),
	  /* scopeId */
	  "data-v-7234b06f",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(535)
	
	var Component = __webpack_require__(4)(
	  /* script */
	  __webpack_require__(360),
	  /* template */
	  __webpack_require__(813),
	  /* scopeId */
	  "data-v-005403a3",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 759 */,
/* 760 */,
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(567)
	
	var Component = __webpack_require__(4)(
	  /* script */
	  __webpack_require__(364),
	  /* template */
	  __webpack_require__(846),
	  /* scopeId */
	  "data-v-4bc87624",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(584)
	
	var Component = __webpack_require__(4)(
	  /* script */
	  __webpack_require__(365),
	  /* template */
	  __webpack_require__(863),
	  /* scopeId */
	  "data-v-6eed899d",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(562)
	
	var Component = __webpack_require__(4)(
	  /* script */
	  __webpack_require__(366),
	  /* template */
	  __webpack_require__(841),
	  /* scopeId */
	  "data-v-3e1e7875",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(586)
	
	var Component = __webpack_require__(4)(
	  /* script */
	  __webpack_require__(367),
	  /* template */
	  __webpack_require__(866),
	  /* scopeId */
	  "data-v-72237c2a",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(572)
	
	var Component = __webpack_require__(4)(
	  /* script */
	  __webpack_require__(368),
	  /* template */
	  __webpack_require__(851),
	  /* scopeId */
	  "data-v-5b8079eb",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(583)
	
	var Component = __webpack_require__(4)(
	  /* script */
	  __webpack_require__(369),
	  /* template */
	  __webpack_require__(862),
	  /* scopeId */
	  "data-v-6c18da00",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(600)
	
	var Component = __webpack_require__(4)(
	  /* script */
	  __webpack_require__(370),
	  /* template */
	  __webpack_require__(880),
	  /* scopeId */
	  "data-v-93171b76",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(551)
	
	var Component = __webpack_require__(4)(
	  /* script */
	  __webpack_require__(371),
	  /* template */
	  __webpack_require__(829),
	  /* scopeId */
	  "data-v-1ba0e6a2",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(576)
	
	var Component = __webpack_require__(4)(
	  /* script */
	  __webpack_require__(372),
	  /* template */
	  __webpack_require__(855),
	  /* scopeId */
	  "data-v-646b1b2c",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(613)
	
	var Component = __webpack_require__(4)(
	  /* script */
	  __webpack_require__(373),
	  /* template */
	  __webpack_require__(893),
	  /* scopeId */
	  "data-v-f55d6608",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 771 */,
/* 772 */,
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(612)
	
	var Component = __webpack_require__(4)(
	  /* script */
	  __webpack_require__(376),
	  /* template */
	  __webpack_require__(892),
	  /* scopeId */
	  "data-v-f514108e",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(563)
	
	var Component = __webpack_require__(4)(
	  /* script */
	  __webpack_require__(377),
	  /* template */
	  __webpack_require__(842),
	  /* scopeId */
	  "data-v-3ffe0a52",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(547)
	
	var Component = __webpack_require__(4)(
	  /* script */
	  __webpack_require__(378),
	  /* template */
	  __webpack_require__(825),
	  /* scopeId */
	  "data-v-12a8a8eb",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(580)
	
	var Component = __webpack_require__(4)(
	  /* script */
	  __webpack_require__(379),
	  /* template */
	  __webpack_require__(859),
	  /* scopeId */
	  "data-v-651e72ce",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(560)
	
	var Component = __webpack_require__(4)(
	  /* script */
	  __webpack_require__(380),
	  /* template */
	  __webpack_require__(839),
	  /* scopeId */
	  "data-v-358a8d04",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(558)
	
	var Component = __webpack_require__(4)(
	  /* script */
	  __webpack_require__(396),
	  /* template */
	  __webpack_require__(836),
	  /* scopeId */
	  "data-v-2e9e8c83",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 792 */,
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(569)
	
	var Component = __webpack_require__(4)(
	  /* script */
	  __webpack_require__(398),
	  /* template */
	  __webpack_require__(848),
	  /* scopeId */
	  "data-v-52a99204",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(609)
	
	var Component = __webpack_require__(4)(
	  /* script */
	  __webpack_require__(399),
	  /* template */
	  __webpack_require__(889),
	  /* scopeId */
	  "data-v-d1c8167c",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(603)
	
	var Component = __webpack_require__(4)(
	  /* script */
	  __webpack_require__(407),
	  /* template */
	  __webpack_require__(883),
	  /* scopeId */
	  "data-v-a494bddc",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(579)
	
	var Component = __webpack_require__(4)(
	  /* script */
	  __webpack_require__(417),
	  /* template */
	  __webpack_require__(858),
	  /* scopeId */
	  "data-v-64a0ed5d",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 813 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "bg"
	  }, [_c('div', {
	    staticClass: "mask"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "loading"
	  }, [_c('i'), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.text))])])])
	},staticRenderFns: []}

/***/ }),
/* 814 */,
/* 815 */,
/* 816 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "cell",
	    class: {
	      'divide-line': _vm.divide
	    },
	    on: {
	      "click": function($event) {
	        _vm.$emit('click')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "left",
	    style: ({
	      color: _vm.leftColor
	    })
	  }, [_vm._v(_vm._s(_vm.leftText))]), _vm._v(" "), _c('div', {
	    staticClass: "right"
	  }, [_vm._t("default")], 2)])
	},staticRenderFns: []}

/***/ }),
/* 817 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.open),
	      expression: "open"
	    }],
	    ref: "popup",
	    staticClass: "dialog-wrapper",
	    style: ({
	      'z-index': _vm.zIndex
	    }),
	    on: {
	      "click": _vm.handleWrapperClick
	    }
	  }, [_c('div', {
	    staticClass: "dialog"
	  }, [_c('div', {
	    staticClass: "body"
	  }, [_vm._v("\n      " + _vm._s(_vm.content) + "\n    ")]), _vm._v(" "), _c('div', {
	    staticClass: "footer"
	  }, [_c('v-button', {
	    staticClass: "left",
	    attrs: {
	      "secondary": "",
	      "text": _vm.cancelText
	    },
	    on: {
	      "click": _vm.cancel
	    }
	  }), _vm._v(" "), _c('v-button', {
	    staticClass: "right",
	    attrs: {
	      "primary": "",
	      "text": _vm.okText
	    },
	    on: {
	      "click": _vm.ok
	    }
	  })], 1)])])
	},staticRenderFns: []}

/***/ }),
/* 818 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.open),
	      expression: "open"
	    }],
	    ref: "popup",
	    staticClass: "dialog-wrapper",
	    style: ({
	      'z-index': _vm.zIndex
	    }),
	    on: {
	      "click": _vm.handleWrapperClick
	    }
	  }, [_c('div', {
	    staticClass: "dialog"
	  }, [_c('div', {
	    staticClass: "title"
	  }, [_vm._v("\n      " + _vm._s(_vm.title) + "\n    ")]), _vm._v(" "), _c('div', {
	    staticClass: "body"
	  }, _vm._l((_vm.contents), function(item, i) {
	    return _c('div', {
	      key: i,
	      staticClass: "item",
	      on: {
	        "click": function($event) {
	          _vm.clickItem(i)
	        }
	      }
	    }, [_vm._v(_vm._s(item) + "\n      ")])
	  })), _vm._v(" "), _c('div', {
	    staticClass: "footer"
	  }, [_c('v-button', {
	    staticClass: "left",
	    attrs: {
	      "secondary": "",
	      "text": _vm.cancelText
	    },
	    on: {
	      "click": _vm.cancel
	    }
	  })], 1)])])
	},staticRenderFns: []}

/***/ }),
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticStyle: {
	      "height": "100%"
	    },
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('keep-alive', [(_vm.$route.meta.keepAlive) ? _c('router-view', {
	    staticClass: "view",
	    staticStyle: {
	      "height": "100%"
	    }
	  }) : _vm._e()], 1), _vm._v(" "), (!_vm.$route.meta.keepAlive) ? _c('router-view', {
	    staticClass: "view",
	    staticStyle: {
	      "height": "100%"
	    }
	  }) : _vm._e(), _vm._v(" "), _c('v-toast', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.toast.show),
	      expression: "toast.show"
	    }],
	    attrs: {
	      "text": _vm.toast.message
	    }
	  }), _vm._v(" "), _c('v-loading', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.show),
	      expression: "loading.show"
	    }],
	    attrs: {
	      "text": _vm.loading.message
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 824 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "cell",
	    on: {
	      "click": function($event) {
	        _vm.$emit('click')
	      }
	    }
	  }, [_vm._t("icon"), _vm._v(" "), _c('div', {
	    staticClass: "left"
	  }, [_c('div', {
	    staticClass: "main"
	  }, [_vm._v(_vm._s(_vm.mainText))]), _vm._v(" "), _c('div', {
	    staticClass: "second"
	  }, [_vm._v(_vm._s(_vm.secondText))])]), _vm._v(" "), (!!_vm.rightText) ? _c('div', {
	    staticClass: "right",
	    style: ({
	      color: _vm.rightColor
	    })
	  }, [_vm._v(_vm._s(_vm.rightText))]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "right-arr"
	  }, [_c('i', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.rightArraw),
	      expression: "rightArraw"
	    }],
	    staticClass: "icon",
	    style: ({
	      color: _vm.rightArrowColor
	    })
	  }, [_vm._v("")])])], 2)
	},staticRenderFns: []}

/***/ }),
/* 825 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "title"
	  }, [_vm._v(_vm._s(_vm.titleText))])
	},staticRenderFns: []}

/***/ }),
/* 826 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "wrapper",
	    on: {
	      "click": _vm.handleClick
	    }
	  }, [_c('div', {
	    staticClass: "image"
	  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
	    staticClass: "title"
	  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', [_c('div', {
	    staticClass: "rightText"
	  }, [_vm._v(_vm._s(_vm.rightText))])]), _vm._v(" "), _c('div', {
	    staticClass: "right-arr"
	  }, [(_vm.showClickIcon) ? _c('i', {
	    staticClass: "icon"
	  }, [_vm._v("")]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "bottom-divide"
	  })])
	},staticRenderFns: []}

/***/ }),
/* 827 */,
/* 828 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "cell"
	  }, [_c('div', {
	    staticClass: "left"
	  }, [_vm._v("菜品")]), _vm._v(" "), _c('div', {
	    staticClass: "right"
	  }, [_vm._v("点餐次数")])])
	}]}

/***/ }),
/* 829 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    class: _vm.getOuterClass(),
	    on: {
	      "click": _vm.click
	    }
	  }, [_vm._t("icon"), _vm._v(" "), _c('div', {
	    staticClass: "contentarea",
	    style: ({
	      'margin-left': _vm.$slots.icon ? '10pt' : '0'
	    })
	  }, [_c('div', {
	    staticClass: "title"
	  }, [_vm._v(_vm._s(_vm.nameString))]), _vm._v(" "), _vm._t("balance")], 2), _vm._v(" "), _c('i', {
	    staticClass: "icon",
	    class: _vm.name === _vm.value ? 'radio-icon-active' : 'radio-icon'
	  }, [_vm._v("")])], 2), _vm._v(" "), _c('div', {
	    staticClass: "bottom-divide"
	  })])
	},staticRenderFns: []}

/***/ }),
/* 830 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.listImg.length > 0) ? _c('swiper', {
	    staticClass: "swiper-box",
	    attrs: {
	      "options": _vm.swiperOption
	    }
	  }, [_vm._l((_vm.listImg), function(item, index) {
	    return _c('swiper-slide', {
	      key: index,
	      staticClass: "swiper-item"
	    }, [_c('img', {
	      attrs: {
	        "src": item.imgUrl
	      },
	      on: {
	        "click": function($event) {
	          _vm.click(index)
	        }
	      }
	    })])
	  }), _vm._v(" "), _c('div', {
	    staticClass: "swiper-pagination swiper-pagination-white",
	    attrs: {
	      "slot": "pagination"
	    },
	    slot: "pagination"
	  })], 2) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "cell"
	  }, [_c('div', {
	    staticClass: "left"
	  }, [_vm._v(_vm._s(_vm.leftText))]), _vm._v(" "), _c('img', {
	    staticClass: "img",
	    attrs: {
	      "src": _vm.imgUrl
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "middle"
	  }, [_vm._v(_vm._s(_vm.middleText))]), _vm._v(" "), _c('div', {
	    staticClass: "right"
	  }, [_vm._v(_vm._s(_vm.rightText))])])
	},staticRenderFns: []}

/***/ }),
/* 836 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "page"
	  }, [_c('div', {
	    staticClass: "content"
	  }, [_c('v-banner', {
	    attrs: {
	      "listImg": _vm.banners
	    },
	    on: {
	      "imgClick": _vm.bannerClick
	    }
	  }), _vm._v(" "), (_vm.isFoxconn) ? _c('v-foxconn', {
	    attrs: {
	      "titleText": "首次充值满5元,送5元"
	    }
	  }) : _vm._e(), _vm._v(" "), _c('v-charge', {
	    attrs: {
	      "text": _vm.balance
	    },
	    on: {
	      "charge": _vm.recharge
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "tiles"
	  }, [_c('v-tile', {
	    attrs: {
	      "src": _vm.billImg,
	      "content": "账单"
	    },
	    on: {
	      "click": function($event) {
	        _vm.$router.push('month-bill')
	      }
	    }
	  }), _vm._v(" "), _c('v-tile', {
	    attrs: {
	      "src": _vm.orderingImg,
	      "content": "订餐"
	    },
	    on: {
	      "click": function($event) {
	        _vm.$router.push('period-list')
	      }
	    }
	  }), _vm._v(" "), _c('v-tile', {
	    attrs: {
	      "src": _vm.takemealImg,
	      "content": "取餐"
	    },
	    on: {
	      "click": function($event) {
	        _vm.$router.push('my-qr-code')
	      }
	    }
	  })], 1)], 1), _vm._v(" "), _c('v-tab', {
	    staticClass: "tab-class",
	    staticStyle: {
	      "background": "white"
	    },
	    attrs: {
	      "active1": true,
	      "active2": false
	    },
	    on: {
	      "click": _vm.tabClick
	    }
	  }), _vm._v(" "), (_vm.qrcodeShow) ? _c('v-qrcode-tip', {
	    staticClass: "qrcode-class",
	    on: {
	      "click": _vm.qrcodeClick
	    }
	  }) : _vm._e(), _vm._v(" "), _c('van-dialog', {
	    attrs: {
	      "title": "长按二维码充值",
	      "confirm-button-text": "关闭"
	    },
	    model: {
	      value: (_vm.show),
	      callback: function($$v) {
	        _vm.show = $$v
	      },
	      expression: "show"
	    }
	  }, [_c('div', {
	    ref: "qrcode",
	    staticStyle: {
	      "display": "flex",
	      "justify-content": "center",
	      "padding": "20px 0"
	    },
	    attrs: {
	      "id": "qrcode"
	    }
	  })])], 1)
	},staticRenderFns: []}

/***/ }),
/* 837 */,
/* 838 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    class: _vm.slideClass
	  }, [_vm._t("default")], 2)
	},staticRenderFns: []}

/***/ }),
/* 839 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "wrapper"
	  }, _vm._l((_vm.titles), function(item, i) {
	    return _c('div', {
	      key: i,
	      staticClass: "tab-item",
	      class: i === _vm.value ? 'active-item' : '',
	      style: ({
	        'flex-basis': 100 / _vm.titles.length + 'vw'
	      }),
	      on: {
	        "click": function($event) {
	          _vm.handleClick(i)
	        }
	      }
	    }, [_vm._v("\n    " + _vm._s(item) + "\n    "), (i === _vm.value) ? _c('div', {
	      staticClass: "bottom-line"
	    }) : _vm._e()])
	  }))
	},staticRenderFns: []}

/***/ }),
/* 840 */,
/* 841 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container",
	    on: {
	      "click": function($event) {
	        _vm.$emit('click')
	      }
	    }
	  }, [(_vm.order.randomDiscountAmount && _vm.order.randomDiscountAmount > 0) ? _c('div', {
	    staticClass: "randomDiscountAmoutContainer"
	  }, [_vm._v("\n    " + _vm._s(("本单减免" + (_vm.formatPrice(_vm.order.randomDiscountAmount)))) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "header"
	  }, [_c('div', {
	    staticClass: "date"
	  }, [_vm._v(_vm._s(_vm.formatDateByDate(_vm.order.consumeDate)) + " ")]), _vm._v(" "), _c('div', {
	    staticClass: "period-name"
	  }, [_vm._v(" " + _vm._s(_vm.order.periodName + ' - ' + _vm.order.hallName) + " ")]), _vm._v(" "), _c('div', {
	    staticClass: "status"
	  }, [_vm._v(_vm._s(_vm.resource.orderStatus[_vm.order.baseOrderViewStatus]))])]), _vm._v(" "), _c('div', {
	    staticClass: "full-divide"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "dishes"
	  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.order.dishes), function(item, i) {
	    return _c('div', {
	      key: i,
	      staticClass: "dish-item"
	    }, [_c('div', {
	      staticClass: "dish-name"
	    }, [_vm._v(" " + _vm._s(item.dishName))]), _vm._v(" "), _c('div', {
	      staticClass: "dish-count"
	    }, [_vm._v(_vm._s(item.count) + " ")]), _vm._v(" "), _c('div', {
	      staticClass: "dish-price"
	    }, [_vm._v(" " + _vm._s(_vm.formatPrice(item.subtotalPrice)))])])
	  })], 2), _vm._v(" "), _c('div', {
	    staticClass: "full-divide"
	  }), _vm._v(" "), (_vm.buttons && _vm.buttons.length > 0) ? _c('div', {
	    staticClass: "footer"
	  }, _vm._l((_vm.buttons), function(item, i) {
	    return _c('div', {
	      key: i,
	      staticClass: "button",
	      class: item.secondy ? 'secondy' : '',
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          _vm.handleClick(item.code)
	        }
	      }
	    }, [_vm._v("\n      " + _vm._s(item.text) + "\n    ")])
	  })) : _c('div', {
	    staticClass: "footer-placeholder"
	  })])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "dish-item"
	  }, [_c('div', {
	    staticClass: "dish-name hint-color"
	  }, [_vm._v("菜品")]), _vm._v(" "), _c('div', {
	    staticClass: "dish-count hint-color"
	  }, [_vm._v("数量 ")]), _vm._v(" "), _c('div', {
	    staticClass: "dish-price hint-color"
	  }, [_vm._v(" 价格")])])
	}]}

/***/ }),
/* 842 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    staticClass: "container",
	    on: {
	      "click": function($event) {
	        _vm.$emit('click')
	      }
	    }
	  }, [_c('div', {
	    attrs: {
	      "align": "center"
	    }
	  }, [_c('img', {
	    staticClass: "tile-image",
	    attrs: {
	      "src": _vm.src
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "title"
	  }, [_vm._v(_vm._s(_vm.content))])])])
	},staticRenderFns: []}

/***/ }),
/* 843 */,
/* 844 */,
/* 845 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "cell",
	    class: {
	      'divide-line': _vm.divide
	    },
	    on: {
	      "click": function($event) {
	        _vm.$emit('click')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "left",
	    style: ({
	      color: _vm.leftColor
	    })
	  }, [_vm._v(_vm._s(_vm.leftText))]), _vm._v(" "), (!!_vm.middleText) ? _c('div', {
	    staticClass: "middle",
	    style: ({
	      color: _vm.middleColor
	    })
	  }, [_vm._v(_vm._s(_vm.middleText))]) : _vm._e(), _vm._v(" "), (!!_vm.rightText) ? _c('div', {
	    class: _vm.singLine ? 'single-line' : 'right',
	    style: ({
	      color: _vm.rightColor
	    })
	  }, [_vm._v(_vm._s(_vm.rightText))]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "right-arr"
	  }, [_c('i', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.rightArraw),
	      expression: "rightArraw"
	    }],
	    staticClass: "icon",
	    style: ({
	      color: _vm.rightArrowColor
	    })
	  }, [_vm._v("")])])])
	},staticRenderFns: []}

/***/ }),
/* 846 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "grid"
	  }, [_c('div', {
	    staticClass: "container",
	    class: _vm.isSuccess === true ? 'success' : 'failure'
	  }, [(_vm.isSuccess) ? _c('div', [_c('i', {
	    staticClass: "icon successColor"
	  }, [_vm._v("")])]) : _vm._e(), _vm._v(" "), (!_vm.isSuccess) ? _c('div', [_c('i', {
	    staticClass: "icon failureColor"
	  }, [_vm._v("")])]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "tipClass",
	    class: _vm.isSuccess === true ? 'successColor' : 'failureTipColor'
	  }, [_vm._v(_vm._s(_vm.tip))])])
	},staticRenderFns: []}

/***/ }),
/* 847 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "img-container"
	  }, [_c('i', {
	    staticClass: "icon code-icon image"
	  }, [_vm._v("")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('img', {
	    staticClass: "qrcode",
	    attrs: {
	      "src": _vm.qrcode
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "bottom-divide"
	  })])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "title"
	  }, [_c('div', {
	    staticClass: "company-name"
	  }, [_vm._v("关注智慧食堂")]), _vm._v(" "), _c('div', {
	    staticClass: "tip-color"
	  }, [_vm._v("长按右边二维码")])])
	}]}

/***/ }),
/* 848 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "page"
	  }, [(_vm.showNOData) ? _c('v-no-data') : _vm._e(), _vm._v(" "), (_vm.calculatedData.length > 0) ? _c('v-cells', {
	    attrs: {
	      "paddingBottom": "20pt",
	      "paddingTop": "3pt",
	      "paddingLeft": "16pt",
	      "paddingRight": "16pt"
	    }
	  }, [_c('v-item-cell', {
	    attrs: {
	      "leftText": "时间",
	      "middleText": "充值金额",
	      "rightText": "消费金额",
	      "middleColor": "#30C37E",
	      "rightColor": "red"
	    }
	  }), _vm._v(" "), _vm._l((_vm.calculatedData), function(item, index) {
	    return _c('v-item-cell', {
	      key: index,
	      attrs: {
	        "leftText": item.date,
	        "middleText": _vm.formatPriceNumber(item.recharges.reduce(function (acc, cur) { return acc += cur.rechargeAmount; }, 0)),
	        "rightText": _vm.formatPriceNumber(item.consumes.reduce(function (acc, cur) { return acc += cur.totalPrice; }, 0)),
	        "middleColor": "#30C37E",
	        "rightColor": "red",
	        "rightArraw": true
	      },
	      on: {
	        "click": function($event) {
	          _vm.detail(item)
	        }
	      }
	    })
	  })], 2) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 849 */,
/* 850 */,
/* 851 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "card",
	    on: {
	      "click": function($event) {
	        _vm.$emit('click')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "left"
	  }, [_c('div', {
	    staticClass: "name"
	  }, [_vm._v("\n      " + _vm._s(_vm.name) + "\n    ")]), _vm._v(" "), _c('div', {
	    staticClass: "employee"
	  }, [_vm._v("\n      工号: " + _vm._s(_vm.employeeNo) + "\n    ")])]), _vm._v(" "), _c('div', {
	    staticClass: "company"
	  }, [_vm._v("\n    " + _vm._s(_vm.companyName) + "\n  ")])])
	},staticRenderFns: []}

/***/ }),
/* 852 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('header', {
	    staticClass: "header"
	  }, [_c('div', {
	    staticClass: "item left"
	  }, [_vm._t("left")], 2), _vm._v(" "), _c('div', {
	    staticClass: "title"
	  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
	    staticClass: "item right"
	  }, [_vm._t("right")], 2)])
	},staticRenderFns: []}

/***/ }),
/* 853 */,
/* 854 */,
/* 855 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('canvas', {
	    staticClass: "main-canvas",
	    attrs: {
	      "id": "canvas"
	    }
	  })])
	}]}

/***/ }),
/* 856 */,
/* 857 */,
/* 858 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "page"
	  }, [_c('v-cells', {
	    attrs: {
	      "paddingBottom": "8pt",
	      "paddingTop": "3pt",
	      "paddingLeft": "16pt",
	      "paddingRight": "16pt"
	    }
	  }, [_c('v-item-cell', {
	    attrs: {
	      "leftText": "充值详情",
	      "leftColor": "black"
	    }
	  }), _vm._v(" "), _c('v-item-cell', {
	    attrs: {
	      "leftText": "充值金额",
	      "rightText": _vm.formatPrice(_vm.data.rechargeAmount)
	    }
	  }), _vm._v(" "), _c('v-item-cell', {
	    attrs: {
	      "leftText": "充值时间",
	      "rightText": _vm.formatTime(_vm.data.rechargeTime),
	      "rightColor": "#A0A1A3"
	    }
	  }), _vm._v(" "), _c('v-item-cell', {
	    attrs: {
	      "leftText": "充值类型",
	      "rightText": _vm.resource.rechargeType.values[_vm.data.rechargeType],
	      "rightColor": "#090A0A"
	    }
	  }), _vm._v(" "), _c('v-item-cell', {
	    attrs: {
	      "leftText": "订单号",
	      "rightText": _vm.data.outPayTradeNo,
	      "rightColor": "#090A0A"
	    }
	  })], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 859 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "toast"
	    }
	  }, [_c('div', {
	    staticClass: "toast"
	  }, [_c('div', {
	    staticClass: "message"
	  }, [_vm._v(_vm._s(_vm.text))]), _vm._v(" "), _c('div', {
	    staticClass: "button",
	    on: {
	      "click": _vm.close
	    }
	  }, [_vm._v("知道了")])])])
	},staticRenderFns: []}

/***/ }),
/* 860 */,
/* 861 */,
/* 862 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "wrapper"
	  }, [_c('div', {
	    staticClass: "title"
	  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
	    staticClass: "qr",
	    class: _vm.disabled === true ? 'disabled' : ''
	  }, [_c('div', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.qrImg)
	    }
	  }), _vm._v(" "), (_vm.status && _vm.status.length > 0) ? _c('v-stamp', {
	    staticClass: "stamp",
	    attrs: {
	      "title": _vm.status,
	      "color": "#898989"
	    }
	  }) : _vm._e()], 1)])
	},staticRenderFns: []}

/***/ }),
/* 863 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "position"
	  }, [_c('div', {
	    staticClass: "content"
	  }, [_c('i', {
	    staticClass: "icon icon-class"
	  }, [_vm._v("")]), _vm._v(" "), _c('div', {
	    staticClass: "title"
	  }, [_vm._v(_vm._s(_vm.titleText))]), _vm._v(" "), _c('div', {
	    staticClass: "footer"
	  })])])
	},staticRenderFns: []}

/***/ }),
/* 864 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "swiper-container"
	  }, [_vm._t("parallax-bg"), _vm._v(" "), _c('div', {
	    class: _vm.defaultSwiperClasses.wrapperClass
	  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("pagination"), _vm._v(" "), _vm._t("button-prev"), _vm._v(" "), _vm._t("button-next"), _vm._v(" "), _vm._t("scrollbar")], 2)
	},staticRenderFns: []}

/***/ }),
/* 865 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    class: _vm.buttonClass,
	    on: {
	      "click": _vm.handleClick
	    }
	  }, [_vm._v("\n  " + _vm._s(_vm.text) + "\n")])
	},staticRenderFns: []}

/***/ }),
/* 866 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "wrapper",
	    on: {
	      "click": _vm.handleClick
	    }
	  }, [_c('div', {
	    staticClass: "left-wrapper"
	  }, [_c('img', {
	    staticClass: "image",
	    attrs: {
	      "src": _vm.imgUrl ? _vm.imgUrl : _vm.noPeriodPic,
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "period-name"
	  }, [_vm._v(_vm._s(_vm.periodName))])]), _vm._v(" "), _c('div', {
	    staticClass: "v-divide"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "right-wrapper"
	  }, [_c('div', {
	    staticClass: "headers"
	  }, [_c('div', {
	    class: _vm.statusClass
	  }, [_vm._v(_vm._s(_vm.getStatusText(_vm.status)) + _vm._s('  ' + (_vm.hallName ? _vm.hallName : '')))])]), _vm._v(" "), (_vm.dishes && _vm.dishes.length >= 0) ? _c('div', {
	    staticClass: "dishes"
	  }, [_vm._v("\n      " + _vm._s(_vm.dishes.join('、')) + "\n    ")]) : _vm._e()])])
	},staticRenderFns: []}

/***/ }),
/* 867 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "cell"
	  }, [_c('div', {
	    staticClass: "left"
	  }, [_vm._v("总共")]), _vm._v(" "), (!!_vm.rightText) ? _c('div', {
	    staticClass: "right"
	  }, [_vm._v(_vm._s(_vm.rightText))]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.open),
	      expression: "open"
	    }],
	    ref: "popup",
	    staticClass: "dialog-wrapper",
	    style: ({
	      'z-index': _vm.zIndex
	    }),
	    on: {
	      "click": _vm.handleWrapperClick
	    }
	  }, [_c('div', {
	    staticClass: "dialog"
	  }, [_c('div', {
	    staticClass: "title"
	  }, [_vm._v("\n      " + _vm._s(_vm.title) + "\n    ")]), _vm._v(" "), _c('div', {
	    staticClass: "body"
	  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
	    staticClass: "footer"
	  }, [_c('v-button', {
	    staticClass: "left",
	    attrs: {
	      "secondary": "",
	      "text": _vm.cancelText
	    },
	    on: {
	      "click": _vm.cancel
	    }
	  }), _vm._v(" "), _c('v-button', {
	    staticClass: "right",
	    attrs: {
	      "primary": "",
	      "text": _vm.okText
	    },
	    on: {
	      "click": _vm.ok
	    }
	  })], 1)])])
	},staticRenderFns: []}

/***/ }),
/* 873 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "date-selector"
	  }, [_c('div', {
	    staticClass: "last-day",
	    class: {
	      'disabled-color': _vm.reachBottom
	    },
	    on: {
	      "click": _vm.clickLast
	    }
	  }, [_vm._v("前一日")]), _vm._v(" "), _c('div', {
	    staticClass: "current-day"
	  }, [_vm._v(_vm._s(_vm.formatDateByDate(_vm.valueDate)))]), _vm._v(" "), _c('div', {
	    staticClass: "next-day",
	    class: {
	      'disabled-color': _vm.reachTop
	    },
	    on: {
	      "click": _vm.clickNext
	    }
	  }, [_vm._v("后一日")])])
	},staticRenderFns: []}

/***/ }),
/* 874 */,
/* 875 */,
/* 876 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "wrapper"
	  }, [_c('div', {
	    staticClass: "input"
	  }, [(_vm.type == 'password') ? _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.inputValue),
	      expression: "inputValue"
	    }],
	    staticClass: "left",
	    attrs: {
	      "placeholder": _vm.hint,
	      "type": "password"
	    },
	    domProps: {
	      "value": (_vm.inputValue)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.inputValue = $event.target.value
	      }
	    }
	  }) : (_vm.type == 'number') ? _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.inputValue),
	      expression: "inputValue"
	    }],
	    staticClass: "left",
	    attrs: {
	      "placeholder": _vm.hint,
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.inputValue)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.inputValue = $event.target.value
	      }
	    }
	  }) : _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.inputValue),
	      expression: "inputValue"
	    }],
	    staticClass: "left",
	    attrs: {
	      "placeholder": _vm.hint,
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.inputValue)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.inputValue = $event.target.value
	      }
	    }
	  }), _vm._v(" "), (!!_vm.rightText) ? _c('div', {
	    class: _vm.rightStyle == 'normal' ? 'right-normal' : 'right-color',
	    on: {
	      "click": function($event) {
	        _vm.$emit('click')
	      }
	    }
	  }, [_vm._v("\n      " + _vm._s(_vm.rightText) + "\n    ")]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "full-divide"
	  })])
	},staticRenderFns: []}

/***/ }),
/* 877 */,
/* 878 */,
/* 879 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "cells",
	    style: (_vm.style)
	  }, [_vm._t("default")], 2)
	},staticRenderFns: []}

/***/ }),
/* 880 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "img-container"
	  }, [_c('img', {
	    staticClass: "qrcode",
	    attrs: {
	      "src": _vm.qrcode
	    }
	  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "close-btn",
	    on: {
	      "click": _vm.click
	    }
	  }, [_vm._v("关闭")])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "title"
	  }, [_c('div', {
	    staticClass: "company-name"
	  }, [_vm._v("关注智慧食堂")]), _vm._v(" "), _c('div', {
	    staticClass: "tip-color"
	  }, [_vm._v("长按左边二维码")])])
	}]}

/***/ }),
/* 881 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "item"
	  }, [_c('div', {
	    staticClass: "left"
	  }, [_c('div', {
	    staticClass: "icon"
	  }, [_vm._v("￥")]), _vm._v(" "), _c('div', {
	    staticClass: "text"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("饭卡余额")]), _vm._v(" "), _c('div', {
	    staticClass: "main"
	  }, [_vm._v(" " + _vm._s(_vm.text) + " ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "right",
	    on: {
	      "click": function($event) {
	        _vm.$emit('charge')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "area"
	  }, [_c('div', {
	    staticClass: "icon"
	  }, [_vm._v("充")]), _vm._v(" "), _c('div', {
	    staticClass: "button",
	    on: {
	      "click": function($event) {
	        _vm.$emit('click')
	      }
	    }
	  }, [_vm._v("充值")])])])])
	},staticRenderFns: []}

/***/ }),
/* 882 */,
/* 883 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "page"
	  }, [(_vm.isFoxconn) ? _c('v-foxconn', {
	    attrs: {
	      "titleText": "首次充值满5元,送5元"
	    }
	  }) : _vm._e(), _vm._v(" "), _c('v-cells', {
	    attrs: {
	      "paddingBottom": "8pt",
	      "paddingTop": "5pt",
	      "paddingLeft": "16pt",
	      "paddingRight": "16pt"
	    }
	  }, [_c('v-item-cell', {
	    attrs: {
	      "leftText": "账户余额",
	      "rightText": _vm.formatPrice(_vm.balance, _vm.user.companyId)
	    }
	  })], 1), _vm._v(" "), _c('v-dialog', {
	    attrs: {
	      "open": _vm.dialog.open,
	      "okText": _vm.dialog.okText,
	      "cancelText": _vm.dialog.cancelText,
	      "content": _vm.dialogContent
	    },
	    on: {
	      "close": function($event) {
	        _vm.dialog.open = false
	      },
	      "cancal": function($event) {
	        _vm.dialog.open = false
	      },
	      "ok": _vm.commit
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 884 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "cell",
	    class: {
	      'divide-line': _vm.divide
	    },
	    on: {
	      "click": function($event) {
	        _vm.$emit('click')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "left",
	    style: ({
	      color: _vm.leftColor
	    })
	  }, [_vm._v(_vm._s(_vm.leftText))]), _vm._v(" "), _c('div', {
	    staticClass: "right",
	    style: ({
	      color: _vm.rightColor
	    })
	  }, [_vm._v(_vm._s(_vm.rightText))]), _vm._v(" "), _c('div', {
	    staticClass: "right-arr"
	  }, [_c('i', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.rightArraw),
	      expression: "rightArraw"
	    }],
	    staticClass: "icon",
	    style: ({
	      color: _vm.rightColor
	    })
	  }, [_vm._v("")])])])
	},staticRenderFns: []}

/***/ }),
/* 885 */,
/* 886 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_c('i', {
	    staticClass: "icon iconsize"
	  }, [_vm._v("")]), _vm._v(" "), _c('div', {
	    staticClass: "title"
	  }, [_vm._v("\n    " + _vm._s(_vm.titleText) + "\n  ")])])
	},staticRenderFns: []}

/***/ }),
/* 887 */,
/* 888 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "mu-overlay-fade"
	    }
	  }, [(_vm.show) ? _c('div', {
	    staticClass: "mu-overlay",
	    style: (_vm.overlayStyle),
	    on: {
	      "click": _vm.handleClick,
	      "touchmove": _vm.prevent
	    }
	  }) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 889 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "page"
	  }, [_c('div', {
	    staticClass: "qr"
	  }, [_c('v-qr-code', {
	    staticClass: "code",
	    attrs: {
	      "qrString": _vm.qrString,
	      "title": "我的取餐码",
	      "status": ""
	    }
	  })], 1), _vm._v(" "), _c('v-button', {
	    staticClass: "button",
	    attrs: {
	      "text": "返回",
	      "primary": ""
	    },
	    on: {
	      "click": function($event) {
	        _vm.$router.back()
	      }
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 890 */,
/* 891 */,
/* 892 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "text-button",
	    on: {
	      "click": function($event) {
	        _vm.$emit('click')
	      }
	    }
	  }, [_vm._v("\n  " + _vm._s(_vm.text) + "\n")])
	},staticRenderFns: []}

/***/ }),
/* 893 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "tabGrid"
	  }, [_c('a', {
	    staticClass: "cell",
	    on: {
	      "click": _vm.click1
	    }
	  }, [_c('div', {
	    staticClass: "cellContent",
	    class: _vm.active1 === true ? 'active' : 'inactivated'
	  }, [_c('i', {
	    staticClass: "icon iconsize"
	  }, [_vm._v("")]), _vm._v(" "), _c('span', [_vm._v("首页")])])]), _vm._v(" "), _c('a', {
	    staticClass: "cell",
	    on: {
	      "click": _vm.click2
	    }
	  }, [_c('div', {
	    staticClass: "cellContent",
	    class: _vm.active2 === true ? 'active' : 'inactivated'
	  }, [_c('i', {
	    staticClass: "icon iconsize"
	  }, [_vm._v("")]), _vm._v(" "), _c('span', [_vm._v("我的")])])])])
	},staticRenderFns: []}

/***/ }),
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),
/* 900 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ })
]);


// WEBPACK FOOTER //
// static/js/app.ee8d641082cbbe5b53c8.js